import { BASE_URL } from '@/utils/host'
import { Cookie } from '@yld/yun-utils-common'
import * as config from './config'

const localLangMap = {
  zh_CN: {
    'packageId': 1,
    'packageName': 'giga',
    'languageCode': 'zh_CN',
    'filedMap': {
      'markupManagement': '加价管理',
      'byPercentageBaseFreightTitle': '按照百分比(基础海运费)',
      'CarrierCode_IsNotEmpty_Exception': '承运人代码不能为空',
      'freightCollectFeeTitle': '到付费用',
      'pleaseEnterSurchargeNamePrompt': '请输入附加费名称',
      'unitTitle': '单位',
      'viewRatePeriodValidityTitle': '查看运价版本有效期',
      'pleaseEnterEnglishVesselPrompt': '请输入英文船名',
      'lineCategoryTitle': '航线分类',
      'viewVersionValidityButton': '查看版本有效期',
      'uploadingFileTitle': '正在上传文件',
      'ContainerSizeType_IsRequired_Exception': '箱型箱量必填',
      'willBeReplacedDirectlyOnlytariffDataUploadWillBeRetainedPrompt': '将直接进行替换，仅保留本次上传运价数据；',
      'commodityArrayTitle': '品名组',
      'operationSuccessPrompt': '操作成功',
      'withinCollectionTitle': '在集合内',
      'FileName_IsRequired_Exception': '文件名称必填',
      'CompanyId_IsRequired_Exception': '所属公司编号必填',
      'contractValidityPeriodExpireNoticeSevenDaysInAdvancePrompt': '合约有效期过期(提前7天进行通知)',
      'approvalTitle': '审核中',
      'rateFailureTimeTitle': '运价失效时间',
      'continueListingButton': '继续上架',
      'ListingProduct_NotExist_Exception': '上架时商品不存在',
      'notmatchComponentTypePrompt': '没有匹配到组件类型',
      'normalTip': '请记得维护运价价格数据哦～',
      'contractManagementMenu': '合约管理',
      'rateInfoTitle': '运价信息',
      'estimatedCostsTitle': '预估费用 ',
      'blankSailingTip': '船期状态修改为空班/停航，请再次确认是否修改？',
      'onlyFullyModifiedListedUnlistedInvalidatedFailedLaunchedStatusRateDataPrompt': '仅支持全量修改【已上架/未上架/已失效/上架失败】状态的运价数据',
      'prebookingDetailMenu': '预订舱详情',
      'notYetTitle': '未',
      'pageStripButton': '条',
      'noOverlapTitle': '无重叠',
      'refuseButton': '拒绝',
      'CarrierCode_IsRequired_Exception': '承运人代码必填',
      'routeTitle': '航线',
      'addRateButton': '新增运价',
      'ProductSnapshotSigningFailed_Exception': '商品快照签名失败',
      'rateTrendTitle': '运价趋势',
      'fieldTypeIsEmptyPrompt': '字段类型为空',
      'yearlyTitle': '每年',
      'shippingContainerVolume': '出运箱量',
      'pleaseSelectCarrierScheduleDataPrompt': '请选择一条船期数据',
      'cutOpenTitle': '截/开',
      'CompanyId_IsNotEmpty_Exception': '所属公司编号不能为空',
      'andTitle': '并且',
      'uploadRecordMenu': '上传记录',
      'variableDefinitionNotExistPrompt': '变量定义不存在',
      'pleaseUploadFilePrompt': '请上传文件',
      'FileInfoDTOList_IsNotEmpty': '文件列表不能为空',
      'editNationalPortSurchargeTitle': '编辑国家港口附加费',
      'Quotation_data_cannot_be_queried': '未查询到报价单数据',
      'remarkTitle': '备注',
      'offlineTitle': '线下',
      'pleaseSelectTransitMethodPrompt': '请选择中转方式',
      'textQuotationTitle': '文本报价',
      'overlappingProcessingTitle': '重叠处理中',
      'FileInformationIsAbnormalPleaseRegenerateTheQuotation_Exception': '文件信息异常，请重新生成报价单',
      'rateMiddlePlatform': '运价中台',
      'ValidityPeriodFromValidTo_GreaterThan_Exception': '起始有效期大于截止有效期',
      'deleteCurrentContractDeleteAllRelatedProductPrompt': '删除当前约，将会删除与约相关的所有商品，是否继续删除？',
      'copiedToClipboardPrompt': '已复制到剪切板！',
      'loadingPortTitle': '起运地',
      'addPriceMarkupRuleTitle': '新增加价规则',
      'freightCollectTotalTitle': '到付合计',
      'QuotationPrices_NotExist_Delete_Exception': '报价单不存在或已被删除',
      'carrierSurchargeTitle': '承运人附加费',
      'daysTitle': '天数',
      'pushChannelsTitle': '推送渠道',
      'tenThousandTitle': '万',
      'quickQuotation': '快速报价',
      'exceptionDataLlineNumberTitle': '异常数据(行号)',
      'onlySupportTitle': '只支持',
      'startPointTitle': '起点',
      'notNullTitle': '不为空',
      'nomarlTitle': '正常',
      'trainloadTitle': '装载量',
      'oceanShippingTitle': '海运',
      'searchButton': '搜索',
      'costPriceTitle': '成本',
      'addFilterProjectButton': '新建筛选方案',
      'releaseDateTitle': '发布时间',
      'confirmWantDeleteProductPrompt': '确定要删除商品吗？',
      'isNullTitle': '为空',
      'addTagButton': '新增标签',
      'railwayTitle': '铁路',
      'ExistSameListedStatusProducts_Exception': '存在相同已上架状态的商品',
      'pleaseEnterKeywordFieldPrompt': '请输入关键词',
      'cancelButton': '取消',
      'disableButton': '禁用',
      'clearLabels': '清除标签(手动)',
      'passedTitle': '已通过',
      'importRateButton': '导入运价',
      'manualAssociation': '手动关联',
      'Content_IsRequired_Exception': '文本报价内容不能为空',
      'parsingPrompt': '解析中',
      'QuotationPrices_AlreadyExists_Exception': '报价单已存在',
      'expectedRiseTitle': '预计上涨',
      'rateMiddleOfficeMenu': '运价中台',
      'estimateDeliveryDateTitle': '预计开航',
      'quotationContent': '报价内容',
      'quotationTimeTitle': '报价时间',
      'RateInfo_AlreadyExists_Exception': '运价信息已存在',
      'inlandPointTitle': '内陆点',
      'contractDetailMenu': '合约详情',
      'pleaseTickFilterDataProceedPrompt': '请勾选或筛选数据，进行',
      'pleaseSelectValidityRangePrompt': '请选择有效期范围',
      'operationStatusTitle': '操作状态',
      'noDataMatchedPrompt': '没有匹配到数据',
      'pleaseSelectSurchargeTypePrompt': '请选择附加费类型',
      'selectAllTitle': '全选',
      'deleteButton': '删除',
      'rateRemarksTitle': '价格备注',
      'wednesdayTitle': '周三',
      'Schedule_IsNotEmpty_Exception': '班期不能为空',
      'remarksInfoTitle': '备注信息',
      'fullShelfButton': '全量上架',
      'CoordinatorIds_IsRequired_Exception': '负责人编号必填',
      'estimatedArrivalScheduleTitle': '预计到港班期',
      'createContainerSizeTypeButton': '添加箱型',
      'pleaseSelectSchedulePrompt': '请选择班期',
      'toBeResolvedTitle': '待解析',
      'latestVersionTitle': '运价最新版本',
      'reviewTheOverlapTitle': '查看重叠',
      'notInCollectionTitle': '不在集合内',
      'continueTakeDownButton': '继续下架',
      'doorToDoorTitle': '点到点查询',
      'rateTypeTitle': '价格类型',
      'UserBranchCompany_IsNotEmpty_Exception': '用户所属分公司不能为空',
      'enabledTitle': '已启用',
      'freightForwardingSurchargeMenu': '货代附加费',
      'lineHeightButton': '行高',
      'contractOwnerTitle': '约主名称',
      'Schedule_IsRequired_Exception': '班期必填',
      'transferPointTitle': '转运点',
      'uploadingFilesPleaseLaterPrompt': '正在上传文件,请稍后...',
      'editContractRateTitle': '编辑合约运价',
      'meetConditionTitle': '满足条件',
      'contractCountTitle': '数量',
      'UserId_IsNotEmpty_Exception': '用户编号不能为空',
      'PorIds_IsRequired_Exception': '装货地编号必填',
      'pageButton': '页',
      'syncSurchargesInfoPrompt': '同步附加费信息',
      'typeTitle': '类型',
      'fieldNameIsEmptyPrompt': '字段名称为空',
      'companyAddressTitle': '公司地址',
      'unlockTitle': '解锁',
      'QuotationNum_IsRequired_Exception': '报价单编号不能为空',
      'ContractInfo_NotExist_Delete_Exception': '合约不存在或已被删除',
      'bulkEnableButton': '批量启用',
      'cancelFilterButton': '取消筛选',
      'thisOperationWillListAllUnlistedDataAfterFilteringPleaseCheckAgainPrompt': '此操作会将筛选后所有未上架的数据进行上架，请再次确认',
      'bySpecificAmountTitle': '按照具体金额',
      'confirmWantDeleteRulePrompt': '确定要删除规则吗？',
      'checkDataMissingMandatoryAutomaticPrompt': '校验数据缺少必填自动（行号）',
      'MakeQuotationsTitle': '制作报价单',
      'downtimeTitle': '下线时间',
      'blueTitle': '蓝色',
      'freightCollectFeeTotalTitle': '到付费用合计',
      'summaryTitle': '摘要',
      'generateQuoteButton': '生成报价单',
      'saveAsButton': '另存为',
      'supportedStatus': '仅支持关联【已上架/未上架/上架失败】状态的运价数据',
      'contactTitle': '联系人',
      'nationalPortSurchargeTitle': '国家港口附加费',
      'scenarioNameAlreadyExistsPrompt': '方案名称已存在',
      'rejectedTitle': '已拒绝',
      'pleaseEnterDestinationPortPrompt': '请输入目的港',
      'modifyCopyText': '您可以修改/复制下面的文本，快速报价',
      'ContainerSizeType_IsNotEmpty_Exception': '箱型箱量不能为空',
      'zeroTitle': '零',
      'confirmWantRemoveProductPrompt': '确定要下架商品吗？',
      'notMatchedPortLineNumberPrompt': '未匹配到港口(行号)',
      'updateTimeTitle': '更新时间',
      'detailTitle': '详情',
      'tagCodeTitle': '标签编码',
      'contractDetailTitle': '合约明细',
      'loadMoreDataTitle': '加载更多数据',
      'confirmWantToBatchDeletePrompt': '确定要批量删除吗?',
      'otherTitle': '其他',
      'ContainerSizeType_IsRepeated_Exception': '箱型不能重复',
      'addSurchargeRuleButton': '新增附加费规则',
      'versionNoTitle': '版本号',
      'exportFreeTimeTitle': '出口免箱期',
      'pleaseSelectBillingUnitPrompt': '请选择计费单位',
      'addScheduleButton': '添加船期',
      'submitFailedTitle': '提交失败',
      'addFederationConditionTitle': '添加联合条件',
      'LineCode_IsRequired_Exception': '航线代码必填',
      'confirmWantPassPrompt': '确定要通过吗？',
      'onlyFullyModifiedUnlistedFailedStatusPrompt': '仅支持全量修改【未上架/上架失败/已失效】状态的数据',
      'nationalPortSurchargeMenu': '国家港口附加费',
      'isLockedTitle': '是否锁定',
      'DestinationId_IsRequired_Exception': '终点编号必填',
      'portOfDischargeTitle': '卸货港',
      'SelectedContractHasRelatedProduct_OperationInvalid_Exception': '所选合约有关联商品，操作无效',
      'pleaseDeleteTheRelevantRatesManagementBeforeDeletingTheContractPrompt': '请在运价管理中删除相关运价后，再删除合约',
      'pleaseTickSurchargePrompt': '请勾选附加费',
      'dateValuePrompt': '日期值',
      'pleaseSelectContainerTypeOrRatePrompt': '请选择箱型或价格',
      'RateAlreadyExistPleaseEditTheBasicInformationOrSailingScheduleInformationAgain_Exception': '运价已存在，请重新编辑基础信息或船期信息',
      'ModifyMarkupRuleFailed_Exception': '修改加价规则失败',
      'chineseNameTitle': '中文名称',
      'confirmWantDisableCurrentContractPrompt': '确定要禁用当前约吗？',
      'saveButton': '保存',
      'destinationPortFeeTitle': '目的港费用',
      'standardContainerTitle': '标准箱',
      'baseFreightTitle': '基础海运费',
      'compactButton': '紧凑',
      'OperatorParams_NotExist_Exception': '操作符参数不存在',
      'loadingPortFeesTitle': '起运地费用',
      'notListedPrompt': '未上架',
      'ProductInfo_NotListed_Exception': '商品未上架',
      'expectedDeclineTitle': '预计下跌',
      'isAllIn': '是否参与ALL IN 计算',
      'pageOfButton': '共',
      'rateTotalTableMenu': '运价总表',
      'rateRecordsMenu': '运价变更记录',
      'rateRecordsDetails': '运价变更详情',
      'otherRemarksTitle': '其他备注',
      'rateNewRemarksTitle': '运价备注',
      'monthTitle': '月',
      'addInlandFreightsTitle': '添加内陆运费',
      'clickMetoCopy': '点我复制',
      'branchManagementMenu': '分公司管理',
      'feeNameTitle': '费用名称',
      'periodValidityTitle': '有效期范围',
      'checkBoxTitle': '复选择框',
      'editSurchargeTitle': '编辑附加费',
      'contractImportTemplateButton': '合约导入模板',
      'approvalStatusTitle': '审核状态',
      'ContactNameTitle': '姓名',
      'bulkDeleteButton': '批量删除',
      'downloadImportTemplateButton': '下载导入模版',
      'ContractInfo_AlreadyExists_Exception': '约已存在',
      'containerCostMenu': '箱成本',
      'expiryDateTitle': '失效时间',
      'closeButton': '关闭',
      'editFilterProjectButton': '编辑筛选方案',
      'guidTitle': '唯一编码',
      'User_NotExist_Exception': '用户不存在',
      'dockTitle': '码头',
      'resetSortTitle': '重置排序',
      'pushContentTitle': '推送内容',
      'freightPrepaidFeeTotalTitle': '预付费用合计',
      'rateResolvedTitle': '运价解析',
      'effectiveDateTitle': '生效时间',
      'listTitle': '列表',
      'surchargeRuleDetailMenu': '附加费规则明细',
      'dataAuthorityManagementMenu': '数据权限管理',
      'costPriceBaseFreightTitle': '成本价(基础海运费)',
      'mondayTitle': '周一',
      'QuotationPrices_NotExist_Exception': '报价单不存在',
      'pleaseSelectContainerTypePrompt': '请选择箱型',
      'pleaseEnterMaximumWeightPrompt': '请输入上限重量',
      'viewButton': '查看',
      'eCommerceRateMenu': '电商运价',
      'associatedLabels': '关联标签',
      'businessTypeTitle': '业务类型',
      'pleaseWaitWhileTheDataLoadsPrompt': '数据加载中，请稍候',
      'ticketTitle': '票',
      'OperationType_IsNotEmpty_Exception': '操作类型不能为空',
      'tagManagement': '标签管理',
      'portSurchargeMenu': '港口附加费',
      'confirmWantDisassociatePrompt': '确定要解除关联吗？',
      'coinTitle': '币制',
      'prebookingMenu': '预订舱',
      'exceptCurrentContactAllProductsRelatedContractDeletedContinueToBeDeletedPrompt': '除当前约，将会删除与约相关的所有商品，是否继续删除？',
      'freightPrepaidCollectTitle': '预付/到付',
      'PleaseDeleteRelevantRateInRateManagementBeforeDeletingContract_Exception': '请在运价管理中删除相关运价后，再删除合约',
      'rateStatusTitle': '运价状态',
      'sundayTitle': '周日',
      'rateAutomaticPutOffNoticePrompt': '运价自动下架通知',
      'dayTitle': '天',
      'afterUnlockingRematchConfirmPrompt': '解锁后将重新匹配规则导入数据，请确认是否解锁？',
      'fullTitle': '爆仓',
      'StartingPointId_IsRequired_Exception': '起点编号必填',
      'startDateTitle': '开始日期',
      'editFreightForwardingSurchargeTitle': '编辑货代附加费',
      'TicketCost_IsRequired_Exception': '票费用必填',
      'detailSummaryTitle': '详细摘要',
      'addSurchargeButton': '新增附加费',
      'closeBillScheduleTitle': '截单班期',
      'ruleImportButton': '规则导入',
      'departureDayTitle': '离港日',
      'editValidityPeriodTitle': '修改有效期',
      'addChargeDetailTitle': '添加费用明细',
      'unloadingPointTitle': '卸货点',
      'pleaseRefreshAndViewLater': '标签数据处理中，请稍后刷新查看',
      'porTitle': '装货地',
      'transferTitle': '中转',
      'parsingSuccessPrompt': '解析成功',
      'pleaseEnterRemarks': '请输入备注信息',
      'confirmWantDisableSurchargeDetailPrompt': '确定要禁用附加费明细吗？',
      'rateDetailMenu': '运价详情',
      'VersionNo_AlreadyExists_Exception': '版本号已存在',
      'directTitle': '直达',
      'YanXuanChannelStatusTitle': '严选分销状态',
      'prebookingRemarkTitle': '预订舱备注',
      'continueTitle': '继续',
      'OperationType_NotExist_Exception': '操作类型不存在',
      'ContainerCost_NotExist_Exception': '箱成本价格不存在',
      'pleaseEnterFeePrompt': '请输入费用',
      'characterTextBoxPrompt': '字符文本框',
      'Failed_To_Generate_Quotation': '报价单生成失败',
      'contractTypeTitle': '约类型',
      'addDischargePointButton': '添加卸货点',
      'historicalSearch': '历史搜索',
      'priceDetailTableMenu': '价格明细表',
      'addOfflineRateButton': '新增线下运价',
      'ssociationType': '关联类型',
      'takeTitle': '取',
      'importExportTitle': '进口/出口',
      'addNationalPortSurchargeTitle': '添加国家港口附加费',
      'productHasBeenRemovedPrompt': '商品已下架',
      'pleaseSelectImportExportTypePrompt': '请选择进口/出口类型',
      'TokenGetFailed_Exception': 'token获取失败',
      'managementSideTitle': '管理端',
      'confirmWantToPrompt': '确定要',
      'fileTitle': '文件',
      'replaceTitle': '修改为',
      'commodityDetailTitle': '品名详情',
      'Quotation_Data_Invalid_Exception': '用于制作报价单的数据无效',
      'englishNameTitle': '英文名称',
      'yearTitle': '年',
      'podTitle': '目的港',
      'confirmWantApprovalPassPrompt': '确定要审核通过吗？',
      'descendingSortTitle': '降序',
      'checkNormadate': '请勾选船期状态【正常】数据！',
      'rateValidityPeriodExpireNoticeOneDaysInAdvancePrompt': '运价有效期过期(提前1天进行通知)',
      'uploadedFreightRateHistoricalFreightRateDataWillBeRetainedPrompt': '本次上传运价和历史运价数据都会保留；',
      'lockedButton': '锁定',
      'confirmEditButton': '确认修改',
      'vesselTitle': '船名',
      'rateImportTemplateTitle': '运价导入模板',
      'orThisTitle': '或者',
      'transitTimeTitle': '航程',
      'bulkButton': '批量操作',
      'PolId_IsNotEmpty_Exception': '起运港编号不能为空',
      'editCarrierSurchargeTitle': '编辑承运人附加费',
      'ListingFailed_Exception': '上架失败',
      'followingConditionsAutomaticallyMatchedRatePrompt': '满足以下条件，自动匹配运价信息',
      'rateSourceTitle': '运价来源',
      'pleaseSelectPushChannelPrompt': '请选择推送渠道',
      'editDetailTitle': '编辑明细',
      'TenantId_IsNotEmpty_Exception': '租户编号不能为空',
      'yourConfirmPrompt': '您确认',
      'TransportationType_IsRequired_Exception': '运输方式必填',
      'SelectDisabledData_Exception': '请选择【已禁用】数据',
      'uploadStatusTitle': '上传状态',
      'pleaseSelectDeparturePortTerminalPrompt': '请选择起运港码头',
      'editInlandFreightsTitle': '编辑内陆运费',
      'SurchargeName_IsRequired_Exception': '附加费名称必填',
      'pleaseAddContainerTypePrompt': '请添加箱型',
      'weekTitle': '周',
      'ProductSnapshotCreateFailed_Exception': '商品快照创建失败',
      'authorityMenu': '权限',
      'rateRepetitionTitle': '运价重叠',
      'loadECommerceDataTitle': '加载电商数据',
      'ValidityPeriod_DataException_Exception': '有效期数据异常',
      'coverHistoricalFreightRatesTitle': '覆盖历史运价',
      'allProjectButton': '全部',
      'defaultConditionsDisplayedPrompt': '默认显示的条件',
      'pleaseSelectTableWithStandardRowColumnDataPrompt': '请选择有标准行列数据表格，',
      'saturdayTitle': '周六',
      'inlandFreightMenu': '内陆运费',
      'inlandFreightMenuNew': '内陆运费',
      'carrierTitle': '承运人',
      'overlapHandledTitle': '重叠已处理',
      'estimateArrPortDateTitle': '预计到港',
      'noDataYetPrompt': '暂无数据',
      'freightTitle': '海运费',
      'importTitle': '进口',
      'overlapTitle': '重叠',
      'successRateTitle': '成功率',
      'bulkImportContractInfoTitle': '批量导入合约信息',
      'serviceMaintainTitle': '航线维护',
      'riseTitle': '上涨',
      'inCabinSystemTitle': '在舱系统',
      'quotationTypeTitle': '报价类型',
      'validityPeriodTitle': '有效期',
      'contractImportButton': '合约导入',
      'ContainerPrice_IsRequired_Exception': '箱型价格必填',
      'MarkupRule_NotExist_Exception': '加价规则不存在',
      'associateLabelFunction': '可通过运价中的【关联标签功能】进行关联标签',
      'ruleCodeTitle': '规则编码',
      'pleaseEnterNameForTheFeePrompt': '请输入费用名称',
      'ImportFileContentAbnormalException_Exception': '导入文件内容异常',
      'addCabinProtectionButton': '添加舱保',
      'newButton': '新建',
      'pleaseSelectCurrencyPrompt': '请选择币种',
      'confirmWantEnableProductPrompt': '确定要启用商品吗？',
      'rateEffectiveTimeTitle': '运价生效时间',
      'downloadFailedTitle': '下载失败',
      'LackTokenUnableToQueryOnlineRates_Exception': '缺少token，无法查询线上运价',
      'portTitle': '港口',
      'addSurchargeTitle': '添加附加费',
      'cabinProtectionInfoTitle': '舱保信息',
      'chargeTypeTitle': '费用类型',
      'Carrier_NotExist_Exception': '承运人不存在',
      'ValidityPeriodRange_IsRequired_Exception': '有效期范围必填',
      'transferPointChargeMenu': '转运点费用',
      'realtimeScheduleTitle': '实时船期',
      'ContractType_IsRequired_Exception': '约类型必填',
      'distributionSystemCodeTitle': '分销系统编码',
      'copyButton': '复制',
      'createrTitle': '创建人',
      'transitTimeDayTitle': '航程(天)',
      'thousandTitle': '千',
      'ascendingSortTitle': '升序',
      'uploadedDatetimeTitle': '上传时间',
      'pleaseEnterDeparturePortTerminalPrompt': '请输入起运港码头',
      'editAllButton': '全量修改',
      'selectRouteCodePrompt': '选择航线代码',
      'LineCategoryId_IsRequired_Exception': '航线分类编号必填',
      'distributionDetailMenu': '分销详情',
      'addFreightForwardingSurchargeTitle': '添加货代附加费',
      'demurrageContainerChargeTitle': '滞箱费',
      'tagStatusTitle': '标签状态',
      'distributionManagementMenu': '分销管理',
      'statusTitle': '状态',
      'rateImportButton': '运价导入',
      'pleaseEnterPortDeparturePrompt': '请输入起运港',
      'confirmButton': '确定',
      'inquiryTitle': '联系TA',
      'rateHistoryRecordTitle': '运价历史记录',
      'createTimeTitle': '创建时间',
      'thePortIsNotMatchedPrompt': '未匹配到港口（行号）',
      'continueDeleteButton': '继续删除',
      'suggestDisableButton': '建议禁用',
      'surchargeNameTitle': '附加费名称',
      'contractStatusTitle': '约状态',
      'SurchargeId_IsRequired_Exception': '附加费编号必填',
      'pleaseConfirmExportInfoPrompt': '请确认导出字段',
      'downloadImportFailedDataTitle': '下载导入失败数据',
      'historicalTariffsAreNotCoveredTitle': '不覆盖历史运价',
      'destinationPortWithContainerFreeMenu': '目的港用箱费',
      'pleaseEnterStartingPointPrompt': '请输入起点',
      'pleaseEnterPrompt': '请输入',
      'validityPeriodEndDateTitle': '有效期结束时间',
      'PodId_IsNotEmpty_Exception': '目的港编号不能为空',
      'confirmWantDeleteCurrentTagPrompt': '确定要删除当前标签吗？',
      'bulkImportRateInfoTitle': '批量导入运价信息',
      'tariffDataSameCarrierContractNumberAlreadyExistsSystemPrompt': '若系统中已存在相同承运人和约号的运价数据，',
      'shippingScheduleInfoTitle': '船期信息',
      'numberTextFieldTitle': '数字文本框',
      'bulkPutOffButton': '批量下架',
      'PortId_IsRequired_Exception': '港口编号必填',
      'CoordinatorIds_IsNotEmpty_Exception': '负责人编号不能为空',
      'dataLoadingPrompt': '数据加载中...',
      'guideAskPriceIsDisplayedAsTheBaseFreightPrompt': '指导卖价作为基础海运费显示',
      'freeDemurrageTitle': '免箱免堆',
      'cellPhoneNoTitle': '手机号',
      'pleaseSelectCarrierSchedulePrompt': '请选择船期',
      'ContainerCost_IsNotEmpty_Exception': '箱成本不能为空',
      'confirmWantEnableCurrentContractPrompt': '确定要启用当前约吗？',
      'demurragePortChargeTitle': '滞港费',
      'IsInclude_IsNotEmpty_Exception': '是否计入总价不能为空',
      'Full_OperationFailed_Exception': '全量修改操作失败',
      'File_GenerateFailed_Exception': '文件生成失败',
      'updaterTitle': '更新人',
      'editOfflineRatesTitle': '编辑线下运价',
      'customizationTitle': '自定义',
      'BaseInfo_IsNotEmpty_Exception': '基础信息不能为空',
      'justSupportTitle': '仅支持',
      'flightScheduleTitle': '开航班期',
      'ContractId_IsRequired_Exception': '约编号必填',
      'hotRateButton': '热门商品',
      'disabledTitle': '已禁用',
      'defaultConditionTitle': '默认条件',
      'directTransferTitle': '中转/直达',
      'chargeStepTitle': '收费阶段',
      'addButton': '添加',
      'FileBeingGeneratedPleaseTryAgainLater_Exception': '文件正在生成，请稍后再试',
      'youCanPrompt': '您可',
      'departmentAuthorityManagementMenu': '部门权限管理',
      'moreConditionsButton': '更多条件',
      'importFreeTimeTitle': '进口免箱期',
      'distributionGoesOfflineMenu': '分销下线',
      'containerTitle': '箱',
      'distributionSystemTitle': '分销系统',
      'arrPortDateTitle': '到港日',
      'confirmWantEnableSurchargeDetailPrompt': '确定要启用附加费明细吗？',
      'chargeTitle': '费用',
      'ImportRecord_NotExist_Exception': '导入记录不存在',
      'pleaseSelectRouteCodePrompt': '请选择航线代码',
      'supplierTitle': '供应商',
      'ContractInfo_NotExist_Exception': '约不存在',
      'SnapshotDigestSigningFailed_Exception': '快照摘要签名失败',
      'fulfillingTitle': '履约中',
      'PodId_IsRequired_Exception': '目的港编号必填',
      'arrivalScheduleTitle': '到港班期',
      'priceValidityPeriodTitle': '价格有效期',
      'shipownerRuleTitle': '船东规则',
      'ValidityPeriod_DataException': '有效期数据异常',
      'copyRateTitle': '复制运价',
      'pleaseEnterCountryPrompt': '请输入国家',
      'addContractTitle': '新增合约',
      'editTagButton': '编辑标签',
      'spaceStatusTitle': '舱位状态',
      'radioTitle': '单选框',
      'manualOfflineTitle': '手动下线',
      'operateTitle': '操作',
      'offlineRateMenu': '线下运价',
      'PaymentMethod_IsNotEmpty_Exception': '付款方式不能为空',
      'containerTypeHasBeenDuplicatedPleaseSelectAgainPrompt': '箱型已重复，请重新选择',
      'changeGuideSalePriceButton': '更新指导卖价',
      'FullPutOff_OperationFailed_Exception': '全量下架操作失败',
      'IsInclude_IsRequired_Exception': '是否计入总价必填',
      'selectDistributionReleaseDataTitle': '选择分销发布数据',
      'putOffButton': '下架',
      'containerTypefreightTitle': '箱型价格',
      'contractParsingTitle': '合约解析',
      'onlyUpToFourBoxTypesCanBeSelectedPrompt': '最多只能选择四种箱型',
      'QuotationInfoList_IsNotEmpty_Exception': '用于快速报价的运价信息不能为空',
      'basicInfoTitle': '基础信息',
      'remainTitle': '保持不变',
      'pleaseEnterContainerCostPrompt': '请输入箱成本',
      'surchargeEnNameTitle': '附加费英文名称',
      'PdlIds_IsRequired_Exception': '卸货港编号必填',
      'otherFreeTitle': '其他费用',
      'entrySalesPointMenu': '进入销售端',
      'pleaseEnterThePrebookingRemarksOptionalPrompt': '请输入预订舱备注信息（选填）',
      'destinationPortFeesTitle': '目的地费用',
      'automaticOfflineTitle': '自动下线',
      'PaymentMethod_IsRequired_Exception': '付款方式必填',
      'pleaseEnterQueryFieldPrompt': '请输入查询字段',
      'pleaseSelectDistributionSystemPrompt': '请选择分销系统',
      'NoTitle': '否',
      'associatedSurchargesButton': '关联附加费',
      'selectScheduleButton': '选择船期',
      'pleaseEnterRulePriorityPrompt': '请输入规则优先级',
      'selectLabel': '请选择标签',
      'SurchargeName_IsNotEmpty_Exception': '附加费名称不能为空',
      'markupInfoFollowsFreightCurrencyPrompt': '那么加价信息如下：（币制使用对应运价信息的基础海运费币制）',
      'exportSelectedDataButton': '导出选中数据',
      'endDateTitle': '结束日期',
      'FileId_IsRequired_Exception': '文件编号必填',
      'Commodity_IsNotEmpty_Exception': '品名不能为空',
      'dragTheFileHereTitle': '将文件拖到此处',
      'createDetailButton': '新增明细',
      'scheduleDataTitle': '船期数据',
      'pleaseSelectModifyDatePrompt': '请选择修改日期',
      'selectContainerTypeHasBeenDuplicatedPleaseSelectAgainPrompt': '选择箱型已重复，请重新选择',
      'addContractRateTitle': '新增合约运价',
      'contractTitle': '合约',
      'soldOutTitle': '售罄',
      'uploadDateTitle': '上传日期',
      'IncludedInTheTotalCostTheFeeIsNoLongerCalculatedPrompt': '已包含在总费用，不再计算费用',
      'saveQuoteButton': '保存报价单',
      'DataSource_IsNotEmpty_Exception': '数据来源不能为空',
      'chargeSourceTitle': '费用来源',
      'lineCodeTitle': '航线代码',
      'redTitle': '红色',
      'syncResourceInfoPrompt': '同步资源信息',
      'weightLimitKgTitle': '限重(KG)',
      'myQuotationMenu': '我的报价单',
      'enableButton': '启用',
      'needToBeChargedAdditionally': '以下费用不包含在总费用中，【需要】额外收取；',
      'alreadyTitle': '已',
      'ofPortsOfCallTitle': '的挂靠港',
      'home': '首页',
      'pleaseEnterNoteHigherValuePrompt': '请输入，注：数值越大优先执行',
      'enterManagementInterfaceMenu': '进入管理端',
      'maximumWeightTitle': '上限重量',
      'afterLockingCurrentRateDataNotBeMatchDataAffectedSupportCustomDataPrompt': '锁定后，本条运价数据将不受匹配数据影响，支持自定义数据',
      'ContractNo_IsRequired_Exception': '约号必填',
      'doNotRequireAdditionalCharges': '以下费用已包含在总费用，【不需要】额外收取；',
      'singleQuoteTitle': '单个报价',
      'hundredsTitle': '百',
      'pleaseSelectChargeTypePrompt': '请选择费用类型',
      'tagNameTitle': '标签名称',
      'surchargeTypeTitle': '附加费类型',
      'ContractInfo_AlreadyExists': '约已存在',
      'containerTypeCostTitle': '箱型成本',
      'polDockTitle': '起运港码头',
      'fullScreenTitle': '全屏',
      'baseFieldTitle': '基础字段',
      'Commodity_IsRequired_Exception': '品名必填',
      'editSurchargeRuleTitle': '编辑附加费规则',
      'quotationNo': '报价单号',
      'GeekYumYanXuanTitle': '极羽严选',
      'rateTitle': '价格',
      'pleaseEnterRuleNamePrompt': '请输入规则名称',
      'SnapshotSigningFailed_Exception': '快照签名失败',
      'exitFullScreenTitle': '退出全屏',
      'defaultCurrentDayDateDisplayedPrompt': '默认显示当天日期，可进行选择',
      'Data_IsRepeated_Exception': '数据重复',
      'orTitle': '或',
      'theSelectedFieldTitle': '选定字段',
      'confirmWantDisableRulePrompt': '确定要禁用标签吗？',
      'quitMenu': '退出',
      'fullDeleteButton': '全量删除',
      'pleaseEnterContentPrompt': '请输入内容',
      'pleaseSelectContractTypePrompt': '请选择约类型',
      'ChargeUnit_IsNotEmpty_Exception': '计费单位不能为空',
      'eCommerceTitle': '电商',
      'markupModeTitle': '加价模式',
      'guideSalePriceIsNotEmptyPrompt': '指导卖价不能为空',
      'looseButton': '宽松',
      'emptyTitle': '清空',
      'freightForwardingSurchargeTitle': '货代附加费',
      'bulkDisableButton': '批量禁用',
      'commoditySingleTitle': '品名',
      'deleteAllButton': '删除所有',
      'experienceRecommendedTheFullOperationDataWithinTwentyThousandPrompt': '为了您的使用体验，建议全量操作数据控制在20000条以内',
      'weightLimitTitle': '限重',
      'RuleName_AlreadyExists_Exception': '规则名称已存在',
      'enterpriseWeChatTitle': '企业微信',
      'BulkEditCanOnlyOperateOnUnlistedProducts_Exception': '批量修改只能操作未上架商品',
      'smsTitle': '短信',
      'contactUsTitle': '联系方式',
      'lockedAfterTitle': '锁定后',
      'saveFilterProjectButton': '保存筛选方案',
      'autoAssociation': '自动关联',
      'costOfPriceTitle': '成本价格',
      'ZaiCangChannelStatusTitle': '在舱分销状态',
      'priorityRulesTitle': '规则优先级',
      'previewTitle': '预览',
      'pleaseEnterContainerTypePrompt': '请输入箱型',
      'declineTitle': '下降',
      'pleaseEnterMinimumWeightPrompt': '请输入下限重量',
      'startMatchingRateRulesAndTagsPrompt': '开始匹配加价规则和标签',
      'submitSuccessTitle': '提交成功',
      'scheduleTitle': '班期',
      'thursdayTitle': '周四',
      'defaultCurrentDayDisplayedCanChooseViewDataUploadedPreviousDatePrompt': '默认显示当天日期，可进行选择查看之前日期上传数据',
      'chargeStatusTitle': '费用状态',
      'pleaseKeepOneConditionPrompt': '请保留一个条件',
      'etaTitle': '到港日期',
      'detailsTitle': '明细',
      'SurchargeCategory_IsRequired_Exception': '附加费类型必填',
      'totaStockTitle': '总库存',
      'keywordTitle': '关键词',
      'paymentMethodTitle': '付款方式',
      'useConditionTitle': '使用条件',
      'freightPrepaidFeeTitle': '预付费用',
      'exportTitle': '出口',
      'outletRateButton': '特价商品',
      'pleaseSelectValidityPrompt': '请选择有效期',
      'carrierSurchargeMenu': '承运人附加费',
      'pleaseTickDataPrompt': '请勾选数据',
      'editContractTitle': '编辑合约',
      'QuotationPricesId_IsNotEmpty_Exception': '报价单编号不能为空',
      'QuotationPrice_IsNotEmpty': '报价单总价不能为空',
      'fileNameTitle': '文件名称',
      'pleaseSelectBusinessTypePrompt': '请选择业务类型',
      'pleaseEnterSupplierPrompt': '请输入供应商',
      'collapseTitle': '收起',
      'tagAlreadyExistsPrompt': '标签已存在',
      'resetButton': '重置',
      'confirmWantDisableCurrentTagPrompt': '确定要禁用当前标签吗？',
      'priceColorTitle': '价格颜色',
      'whetherTitle': '是否',
      'containerYardFreetimeTitle': '堆场免箱期',
      'ProductInfo_NotExist_Delete_Exception': '商品不存在或已删除',
      'pleaseEnterKeywordPrompt': '请输入关键字',
      'distributionReleaseMenu': '分销发布',
      'PolId_IsRequired_Exception': '起运港编号必填',
      'equalsTitle': '等于',
      'fullOperationTitle': '全量操作',
      'currencyTitle': '币种',
      'varietyContainerTitle': '箱种类',
      'pleaseAddContainerTypeAccordingMarkupModelPrompt': '请根据加价模式添加箱型',
      'clickUploadButton': '点击上传',
      'AddMarkupRuleFailed_Exception': '添加加价规则失败',
      'initializeRateInfoPrompt': '初始化商品信息',
      'BulkOperationsCanOnlyBePerformedWithDataFromDisabledFulfilledContracts_Exception': '批量操作只有禁用、履约中的数据能进行',
      'Currency_IsRequired_Exception': '币种必填',
      'pdlTitle': '目的地',
      'IsAllInCalculate_IsRequired_Exception': '是否参与ALL IN计算必填',
      'releaseSuccessTitle': '发布成功',
      'pleaseEnterTagNamePrompt': '请输入标签名称',
      'shippingCancellationTitle': '停航',
      'clickEnterTitle': '点击回车',
      'containerYardChargeTitle': '堆场费',
      'ScheduleData_IsRepeated_Exception': '船期数据不能重复',
      'ValidityPeriod_IsNotEmpty_Exception': '有效期不能为空',
      'emailTitle': '邮件',
      'stripRateTitle': '条运价',
      'selectedFieldsTitle': '选中字段(可拖拽排序)',
      'pleaseEnterDestinationTitle': '请输入目的地',
      'ContainerPrice_IsNotEmpty_Exception': '箱型价格不能为空',
      'estimatedDepartureScheduleTitle': '预计离港班期',
      'CurrentContractExistProductBindingPleaseNotModifyContractNoCarrier_Exception': '当前合约下存在商品绑定，请勿修改约号和承运人',
      'conditionTitle': '条件',
      'podDockTitle': '目的港码头',
      'submissionTimeTitle': '提交时间',
      'pleaseSelectRateTypePrompt': '请选择运价类型',
      'carrierCompanyTitle': '船公司',
      'contractNoTitle': '约号',
      'loadingTitle': '正在加载',
      'emptyCacheMenu': '清空缓存',
      'partialParsingSuccessPrompt': '部分解析成功',
      'uploadSuccessCanViewParsingResultUploadRecordPrompt': '上传成功，可在上传记录中查看解析结果～',
      'nationalDockRuleTitle': '国家码头规则',
      'displayColumnButton': '显示列',
      'pleaseEnterRouteCodePrompt': '请输入航线代码',
      'portMatchingSuccessRatePrompt': '港口匹配成功率',
      'throughTitle': '通过',
      'monthlyTitle': '每月',
      'pleaseSelectCarrierPrompt': '请选择承运人',
      'feeDetailsTitle': '费用明细',
      'notTitle': '无',
      'fullVolumeGoesOfflineMenu': '全量下线',
      'rateLabel': '运价标签',
      'specialContainerTitle': '特种箱',
      'batchEditValidityPeriodButton': '全量修改有效期',
      'modesTransportTitle': '运输方式',
      'greenTitle': '绿色',
      'purpleTitle': '紫色',
      'viewDetailButton': '查看详情',
      'shippingScheduleEmptyTitle': '空班',
      'bulkPutOnButton': '批量上架',
      'youCanDownloadImportTemplateToImport': '您可下载导入模版进行导入',
      'pleaseCheckFilterDataPerformOperationPrompt': '请勾选或筛选数据，进行操作',
      'clearTheLabel': '确定要清除标签吗？',
      'MessageNoticePushId_IsNotEmpty_Exception': '消息通知推送编号不能为空',
      'Currency_IsNotEmpty_Exception': '币种不能为空',
      'saveSuccessfullyPleaseCheckMyQuotePrompt': '保存成功，请在我的报价单查看',
      'toImportPrompt': '进行导入',
      'pleaseSelectPrompt': '请选择',
      'ProductId_IsNotEmpty_Exception': '商品编号不能为空',
      'containerVolumeTitle': '箱量',
      'pleaseSelectCommodityGroupPrompt': '请选择品名组',
      'downlinePersonTitle': '下线人',
      'GuideSalePrice_IsNotEmpty_Exception': '指导卖价不能为空',
      'historyVersionTitle': '运价历史版本',
      'publisherTitle': '发布人',
      'scheduleSourceTitle': '船期来源',
      'fridayTitle': '周五',
      'etdTitle': '开航时间',
      'makeSureSystemFieldPresentHeaderPrompt': '并确保标题中存在系统字段，',
      'uploadedPersonTitle': '上传人',
      'pleaseSelectRateStatusPrompt': '请选择运价状态',
      'overwriteLegacyScenarioPrompt': '覆盖原有方案',
      'isDisabledTitle': '是否禁用',
      'conditionComparatorIsEmptyPrompt': '条件比较符为空',
      'surchargeDetailsMenu': '附加费明细',
      'pleaseEnterPlaceOfReceiptTitle': '请输入出发地',
      'quotationNumberTitle': '报价编号',
      'cascadeAddressesTitle': '级联地址',
      'QuotationSurchargeInfo_IsNotEmpty': '报价单费用明细信息不能为空',
      'enoughTitle': '充足',
      'salesSideTitle': '销售端',
      'freightPrepaidTotalTitle': '预付合计',
      'includeOrNotTitle': '总价是否包含',
      'pleaseEnterContainerSizeTypePrompt': '请输入箱型数量',
      'pleaseSelectARouteCodePrompt': '请选择一条航线代码',
      'rateManagementMenu': '运价管理',
      'productManagementMenu': '产品管理',
      'expandTitle': '展开',
      'priorityTitle': '优先级',
      'advanceTitle': '提前',
      'closeBillDateTitle': '截单时间',
      'deleteCurrentMarkupRulePrompt': '删除当前规则，将会自动取消相关商品的加价信息，是否继续删除？',
      'freetimeDayTitle': '免箱天数',
      'lowerLimitWeightTitle': '下限重量',
      'MessageType_IsNotEmpty_Exception': '消息类型不能为空',
      'confirmWantShelvesProductPrompt': '确定要上架商品吗？',
      'CarrierId_IsRequired_Exception': '承运人编号必填',
      'exportAllDataButton': '导出所有数据',
      'chargeTicketTitle': '费用(票)',
      'rateDataHasChangedRateLockedNotTriggeredMatchRulePrompt': '运价数据已变更，且运价为锁定状态，不会触发规则匹配，是否继续？',
      'scheduleDataDuplicatedPleaseSelectAgainPrompt': '船期数据已重复，请重新选择',
      'The_Amount_Of_Data_Is_Too_Large': '用于生成报价单的运价数量超过最大限制',
      'markupCoveragePrompt': '加价覆盖率',
      'ruleNameTitle': '规则名称',
      'moderateButton': '适中',
      'rolePermissionManagementMenu': '角色权限管理',
      'bargeTitle': '驳船',
      'QuotationPricesRateDetail_IsNotEmpty_Exception': '报价单运价明细不能为空',
      'listingFailedPrompt': '上架失败',
      'distributionStatusTitle': '分销状态',
      'voyageTitle': '航次',
      'addUnloadingPointButton': '添加卸货点',
      'bulkQuotesTitle': '批量报价',
      'closePortDateTitle': '截港时间',
      'TelTitle': '电话',
      'confirmWantDeleteSurchargePrompt': '确定要删除附加费吗？',
      'bulkEditValidityPeriodButton': '批量修改有效期',
      'modifyButton': '修改',
      'PortCode_IsRequired_Exception': '港口代码必填',
      'dataSourceTitle': '数据来源',
      'QueryParams_IsNotEmpty_Exception': '查询条件不能为空',
      'bulkMakeQuotationsMenu': '批量制作报价单',
      'systemSettingMenu': '系统配置',
      'yesTitle': '是',
      'listingProcessingPrompt': '上架处理中',
      'disassociationButton': '解除关联',
      'closePortScheduleTitle': '截港班期',
      'SelectedAll_IsNotEmpty_Exception': '是否选中全部不能为空',
      'keepTitle': '维持',
      'nationalTitle': '国家',
      'distributionRateMenu': '分销运价',
      'thisWillRemoveAllFilteredDataFromTheShelvesPleaseCheckAgainPrompt': '此操作会将筛选后所有已上架的数据进行下架，请再次确认',
      'feederChargesMenu': '支线费用',
      'shipOperatorTitle': '船舶运营人',
      'ChargeUnit_IsRequired_Exception': '计费单位必填',
      'endPointTitle': '终点',
      'sortNoTitle': '序号',
      'TicketCost_IsNotEmpty_Exception': '票费用不能为空',
      'rateValidityPeriodTitle': '运价有效期',
      'departurePortFeeTitle': '起运港费用',
      'filterButton': '筛选',
      'billingUnitTitle': '计费单位',
      'editPriceMarkupRuleTitle': '编辑加价规则',
      'flushButton': '刷新',
      'importContractButton': '导入合约',
      'validityPeriodStartDateTitle': '有效期开始时间',
      'personalSettingMenu': '个人设置',
      'downlineTitle': '下线',
      'fullDelistingButton': '全量下架',
      'updateRateInfoPrompt': '更新商品信息',
      'pleaseSelectPriceColorPrompt': '请选择价格颜色',
      'IsAllInCalculate_IsNotEmpty_Exception': '是否参与ALL IN计算不能为空',
      'myPrebookingMenu': '我的预订舱',
      'firstVesselTitle': '头程船',
      'setTheListTitle': '设置列',
      'placeDepartureTitle': '出发地',
      'pleaseSelectPaymentMethodPrompt': '请选择付款方式',
      'pleaseSelectCarrierScheduleStatusPrompt': '请选择船期状态',
      'distributionPriceTitle': '分销价格',
      'rateInquiryMenu': '运价查询',
      'QuotationPricesType_NotExist_Exception': '报价单类型不存在',
      'SelectedDataIsBeingModifiedOrIsNotEligibleForEditingPleaseTryAgainLater_Exception': '所选数据正在修改中或不符合修改条件，请稍后再试',
      'ParseMode_IsRequired_Exception': '解析模式必填',
      'cabinProtectionInfoRepeatedPrompt': '舱保信息已重复',
      'addCarrierSurchargeTitle': '添加承运人附加费',
      'closeOtherButton': '关闭其他',
      'parsingFailedPrompt': '解析失败',
      'freeDetentionMenu': '免箱期',
      'freeDetentionDetailMenu': '免箱期详情',
      'operationFailedPrompt': '操作失败',
      'InitializationRateVersionInfoFailed_Exception': '初始化运价版本信息失败',
      'tuesdayTitle': '周二',
      'confirmWantToDeletePrompt': '确定要删除吗？',
      'surchargeManagementMenu': '附加费管理',
      'listedTitle': '已上架',
      'confirmWantRefusePrompt': '确定要拒绝吗？',
      'pleaseEnterMarkupAmountPrompt': '请输入加价金额',
      'ProductInfo_Exception': '商品信息异常',
      'DataAlreadyExists_Exception': '数据已存在',
      'expiredTitle': '已失效',
      'duplicateDataLineNumberTitle': '重复数据(行号)',
      'downlineTypeTitle': '下线类型',
      'companyTitle': '所属公司',
      'SubscriptionIdMissing_Exception': '缺少订阅id',
      'confirmWantDisableProductPrompt': '确定要禁用商品吗？',
      'dataDuplicationPrompt': '出现重复数据（行号）',
      'pleaseSelectShippingMethodPrompt': '请选择运输方式',
      'associatedSurchargeDetailTitle': '关联附加费明细',
      'createProjectButton': '新建方案',
      'preBookingOrderApproveNoticePrompt': '预订舱订单审核通知',
      'DataStatusOfTheSelectedDataIsNotEligibleForModificationPleaseTryAgainLater_Exception': '所选数据的数据状态不符合修改条件，请稍后再试',
      'notStartedTitle': '未开始',
      'freightPrepaidTitle': '预付',
      'moduleTitle': '模块',
      'pleaseEnterContractNoPrompt': '请输入约号',
      'putOnButton': '上架',
      'VersionNo_GenerateFailed_Exception': '版本号生成失败',
      'pleaseEnterPortPrompt': '请输入港口',
      'guideSalePriceTitle': '指导卖价',
      'editButton': '编辑',
      'polTitle': '起运港',
      'distributionMarkupTitle': '分销加价',
      'employeeManagementMenu': '员工管理',
      'confirmWantGoOfflinePrompt': '确定要下线商品吗？',
      'dingTalkTitle': '钉钉',
      'weeklyTitle': '每周',
      'editRateTitle': '编辑运价',
      'trailerTitle': '拖车',
      'systemContractNoTitle': '系统约号',
      'goToPageButton': '前往页',
      'promptTitle': '提示',
      'pleaseSelectRouteCategoryPrompt': '请选择航线分类',
      'SurchargeName_IsRepeated_Exception': '附加费名称重复',
      'contractIdTitle': '约ID',
      'ScheduleStatus_IsNotEmpty_Exception': '船期状态不能为空',
      'delayTitle': '延期',
      'onlyModifiedUnlistedFailedRateStatusPrompt': '仅支持修改【未上架/上架失败/已失效】状态的运价',
      'pleaseSelectOwnerPrompt': '请选择负责人',
      'freightCollectTitle': '到付',
      'transferTerminalTitle': '中转港',
      'pleaseEnterDestinationPortTerminalPrompt': '请输入目的港码头',
      'moreButton': '查看更多',
      'confirmWantEnableRulePrompt': '确定要启用标签吗？',
      'Surchargefullamountmodification': '仅支持修改【已启用/已失效/未开始】',
      'pleaseEnterEndPointPrompt': '请输入终点',
      'setTheListDisplayFieldTitle': '设置列表显示字段',
      'FileUrlNotFound_Exception': '未找到文件URL',
      'editValidityPeriodButton': '修改版本有效期',
      'RateValidityPeriod_IsRepeated_Exception': '运价有效期重复',
      'rateAnalysisCompletedPrompt': '运价解析完成',
      'theActualPriceIsSubjectToTheShippingCompanyPrompt': '实际价格以船公司为准',
      'surchargeRulesMenu': '货代规则',
      'organizationMenu': '组织机构',
      'BatchModifyParams_IsNotEmpty_Exception': '批量修改参数不能为空',
      'thisWillDeleteAllFilteredDataPleaseConfirmAgainPrompt': '此操作会将筛选后所有数据进行删除，请再次确认',
      'onlyModifiedListedUnlistedInvalidatedFailedLaunchedRateStatusPrompt': '仅支持修改【未上架/已失效/已上架/上架失败】状态的运价',
      'uploadSuccessParsingResultUploadRecordPrompt': '上传成功，可在上传记录中查看解析结果',
      'receiveTaskRateResolutionPrompt': '收到运价解析任务',
      'PleaseSelectDataInUse_Exception': '请选择【使用中】数据',
      'FullListing_OperationFailed_Exception': '全量上架操作失败',
      'messageRemindSettingMenu': '消息提醒设置',
      'distributionSuccessMenu': '分销成功',
      'surchargeMenu': '附加费',
      'costPriceUsdTitle': '成本(USD)',
      'QuotationContainerInfo_IsNotEmpty': '报价单箱型数量不能为空',
      'historyProjectedTitle': '历史预计',
      'ProductInfo_NotExist_Exception': '商品不存在',
      'pleaseSelectDestinationTerminalDockPrompt': '请选择目的港码头',
      'loadScheduleDataTitle': '加载船期数据',
      'containerSizeTypeTitle': '箱型',
      'submitterTitle': '提交人',
      'exportButton': '导出',
      'SurchargeCategory_IsNotEmpty_Exception': '附加费类型不能为空',
      'scheduleStatusTitle': '船期状态',
      'ownerTitle': '负责人',
      'ContainerCostUpdateInfo_IsNotEmpty_Exception': '箱成本修改信息不能为空',
      'filterCriteriaTitle': '筛选条件',
      'downloadTitle': '下载',
      'contractRateMenu': '合约运价',
      'onlineImportTitle': '线上导入',
      'OnlineRateInquiryFailed_Exception': '线上运价查询失败',
      'nervousTitle': '紧张',
      'SystemErrorException': '系统错误',
      'TimeOutErrorException': '网络超时',
      'LanguageResource_IsNotExist_Exception': '语言资源不存在',
      'RpcErrorException': '第三方调用错误',
      'NeedLoginException': '未登录',
      'LanguageResourceKey_AlreadyExists_Exception': '语言资源Key已存在',
      'LanguageName_IsNotEmpty_Exception': '语言名称不能为空',
      'InvalidParamsException': '参数异常',
      'WrongParamsException': '参数解析错误',
      'ApplicationErrorException': '应用错误',
      'Page_IsNotEmpty_Exception': '页码不能为空',
      'LanguagePackage_IsNotNull_Exception': '语言包不存在',
      'LanguagePackageId_IsNotEmpty_Exception': '语言包编号不能为空',
      'LanguageResourceType_IsNotEmpty_Exception': '语言资源类型不能为空',
      'PackageName_IsNotEmpty_Exception': '语言包名称不能为空',
      'InterfaceErrorException': '接口调用错误',
      'LanguagePackage_IsNotExist_Exception': '语言包不存在',
      'AppActionErrorException': '应用错误，可控制客户端行为',
      'SuccessException': '调用成功',
      'PageSize_IsNotEmpty_Exception': '页数不能为空',
      'LanguageResourceId_IsNotEmpty_Exception': '语言资源编号不能为空',
      'modificationTime': '修改时间',
      'modifier': '修改人',
      'eventTypeTitle': '事件类型',
      'boxGenus': '箱属',
      'batchCopy': '批量复制',
      'bulkCopyTips1': '若以下字段输入内容，按照输入后的内容更新复制数据；',
      'bulkCopyTips2': '若以下字段不输入内容，保持运价现有数据进行复制；',
      'checkThisTime': '本次勾选',
      'successfullyCopied': '复制成功',
      'tradeTitle': '路径',
      'spotRateTitle': '特价',
      'seawinSystem': '海盟系统',
      'seawinDistributionStatus': '海盟分销状态',
      'offlineNotSupported': '暂不支持下线',
      'rateOverview': '运价概览',
      'listedRatesClassifiedByRoute': '已上架运价按航线分类',
      'realtimeData': '实时数据',
      'rateInquiryQuotationRankingList': '运价查询/报价排行榜',
      'lastWeek': '最近一周',
      'inquiryWithResultOrNot': '查询结果有无运价',
      'abnormalPrice': '卖价异常',
      'abnormalMatchingOfVoyageSchedule': '船期匹配异常',
      'rateExpirationWarning': '运价过期预警',
      'inquiryCounts': '总查询次数',
      'numberOfVoyageScheduleMatchingHits': '船期匹配命中次数',
      'dashboard_filter_branchs': '所属分公司',
      'numberOfVoyageScheduleMatchingFailed': '船期匹配失败次数',
      'failureRate': '失败率',
      'expiredIn3Days': '未来3天过期',
      'expiredIn10Days': '未来10天过期',
      'expiredIn30Days': '未来30天过期',
      'homePageHI': '你好',
      'thisIsYourNO': '这是你第',
      'login': '次登录系统',
      'cabinCapacity': '舱量',
      'numberOfCabins': '舱位数',
      'bookingQuantity': '订舱余量',
      'subjectToConfirmationWithTheRoute': '与航线确认为准',
      'expireds': '已过期',
      'totalRate': '运价总量',
      'commonFunctions': '常用功能',
      'costGuidedsellingPrice': '成本价/指导卖价',
      'inquiryHome': '询价',
      'quotationHome': '报价',
      'noRate': '无运价',
      'rateAvailable': '有运价',
      'dataBI': '数据统计',
      'noDistribution': '未分销',
      'distributionFailure': '分销失败',
      'inDistribution': '分销中',
      'addDnd': '新增免箱期',
      'editDnd': '编辑免箱期',
      'exemptionPeriodInformation': '免箱期信息',
      'enterTheNumberOfFreeDays': '请输入免费天数',
      'selectDndType': '请选择免箱期类型',
      'freeTime': '总免箱期(场内+场外)',
      'demurrageDay': '免箱期（堆场外）',
      'detentionDay': '免堆期（堆场内）',
      'dayType': '天数类型',
      'dndType': '免箱期类型',
      'originalid': '原数据编码',
      'rateSource': '价格来源',
      'offlineSelectedRate': '将选中运价下线',
      'NoNeedToSelectAllRatesWillBeOffline': '无需选中，将筛选结果全量下线，请谨慎操作，仅支持极羽严选。',
      'NoNeedToSelectAllRatesWillBDistributed': '无需选中，将筛选结果全量分销。',
      'distributAll': '全量分销',
      'areYouSureFullDistribution': '确定要全量分销吗?',
      'areYouSureYouWantOfflineAllRate': '确定要全量下线吗？',
      'automaticDistributionRateMenu': '自动分销',
      'addDistributionRule': '新增分销规则',
      'editDistributionRule': '编辑分销规则',
      'pleaseSelectAtLeasOne': '以下筛选条件,请至少选择一个',
      'podNationalTitle': '目的港国家',
      'ifETD': '是否有ETD',
      'isOMSBinding': '是否与OMS绑定',
      'lastModify': '最后修改人',
      'lastModifyTime': '最后修改时间',
      'Exporting': '导出中',
      'dataNotBoundOMS': '未与OMS绑定的数据',
      'modificationOfMarkupRules': '加价规则修改后，为了价格计算的准确性，系统已存在的运价，请30分钟后再进行操作；',
      'announcementSet': '系统公告设置',
      'newAnnouncement': '新增公告',
      'editAnnouncement': '编辑公告',
      'announcementContent': '公告内容',
      'announcementValidityPeriod': '公告有效期',
      'updatedByDepartment': '更新人所属部门',
      'realTimePopupDisplay': '实时弹窗展示',
      'realTimeScrollingDisplay': '实时滚动展示',
      'enablePopup': '开启弹窗',
      'cancelPopup': '取消弹窗',
      'enableScrolling': '开启滚动',
      'cancelScrolling': '取消滚动',
      'systemAnnouncement': '系统公告',
      'publisher': '发布人',
      'todayAc': '今日公告',
      'yesterdayAc': '昨日公告',
      'allAc': '查看更多',
      'announcementSwitch': '公告开关',
      'wccPlatform': 'WCC平台',
      'wccDistributionStatus': 'WCC分销状态',
      'freightCode': '运价编码',
      'distributionCode': '分销编码',
      'queryTime': '查询时间',
      'freightStatusChangeTitle': '运价状态变更',
      'priceMarkup1': '提交加价规则后，系统需要一定时间处理，请30min后再对系统已存在运价进行其他操作',
      'priceMarkup2': '提交后只会自动对未上架或上架失败的运价进行加价，如需对已上架运价修改，可以先下架后再修改加价规则',
      'changeRecord2': '运价变更记录只记录线下运价表，每3min更新一次',
      'changeRecord1': '变更内容已标记为红色',
      'viewPriceMarkupRuleTitle': '查看加价规则',
      'enterAisc': '进入解析平台',
      'yaDongChannelStatus': '亚东分销状态',
      'anHaiChannelStatus': '安海分销状态',
      'anHaiChannelYaDong': '安海分销亚东',
      'loxsonYaDong': 'LOXSON亚东',
      'quanQiuChannelJinCheng': '全球分销锦程',
      'jinChengChannelStatus': '锦程分销状态',
      'contractOrBatch': '约号/批次号',
      'underModification': '修改中',
      'batchNoTitle': '批次号',
      'rateSubscribed': '运价订阅',
      'rateSubscribed1': '运价订阅',
      'subscription': '订阅',
      'unSubscribe': '取消订阅',
      'subscribedService': '已订阅航线',
      'subscribedCarrier': '已订阅承运人',
      'numberRates': '可订阅运价条数',
      'subOption': '订阅选项',
      'PleaseSelectItem': '请至少选择一项',
      'salesCompanyDisplay': '销售端所属公司显示',
      'displaySalesContactPerson': '销售端所属联系人显示',
      'subscriptionSuccessful': '订阅成功',
      'selected': '已选择',
      'successfullySubscribedSalesEnd': '条运价已经订阅成功，请到【线下运价】进行管理并操作上架',
      'automaticallyNeeded': '每日自动更新已订阅的航线、承运人运价，如不需要可',
      'subscribedList': '已订阅清单',
      'afterCancel': '取消订阅后，将不会再获得来自该供应商的运价，确定取消吗？',
      'deselectAll': '取消全选',
      'subscribableService': '可订阅航线',
      'subscribableCarrier': '可订阅承运人',
      'settingShippingSchedule': '船期班期设置',
      'salesEntrance': '销售端入口',
      'polCode': '起运港五字码',
      'podCode': '目的港五字码',
      'contractType': '合约类型',
      'carriageClause': '运输条款',
      'append': '补充',
      'defaultSupplier': '默认供应商',
      'guidingSellingPrice': '是否为指导卖价',
      'automaticallyMarkup': '运价导入系统自动匹配加价规则，同步生成指导卖价。',
      'automaticallyNoMarkup': '运价导入系统不再匹配加价规则，直接获取为指导卖价。',
      'isItPlacedOnTop': '是否置顶',
      'top': '置顶',
      'cancelTop': '取消置顶',
      'areYouSureYouWanOnTop': '确定要置顶吗？',
      'areYouSureYouWantCancelTopPlacement': '确定要取消置顶吗？',
      'import': '导入',
      'departureSectionCost': '起运段费用',
      'destinationSectionCost': '目的段费用',
      'inlandFreightDetails': '内陆运费详情',
      'copyInlandFreights': '复制内陆运费',
      'porDockTitle': '装货地码头',
      'pleaseEnterTheFeeDetails': '请输入费用明细',
      'inEffect': '生效中',
      'theInlandFreight': '内陆运费更新后需重新上架运价才会生效',
      'associateOrigin': '关联起运段运费',
      'associateDestination': '关联目的段运费',
      'generalCargoSchedule': '散杂货船期',
      'searchRecs': '查询记录',
      'destinationPortLineTitle': '目的地航线',
      'searchType': '查询类型',
      'userSource': '用户来源',
      'username': '用户名',
      'mailbox': '邮箱',
      'searchResult': '查询结果',
      'shippingSpaceRemind': '舱位提醒',
      'addShippingSpaceRemind': '新增舱位提醒',
      'editShippingSpaceRemind': '编辑舱位提醒',
      'copyShippingSpaceRemind': '复制舱位提醒',
      'exportTime': '导出时间',
      'inlandFreightRateImportButton': '内陆运费导入',
      'contractSetting': '合约设置',
      'automaticOverlappingCorrection': '重叠自动修正',
      'overlapAndConnection': '重叠时衔接',
      'disableDuringOverlap': '重叠时禁用',
      'noNotEnableCorrection': '不启用修正',
      'whenTheSystemDetectsOverlappingContractDates:': '系统检测到合约日期重叠时',
      'contractStartTimeDay': '若运价有效期是交集关系，旧合约结束时间改为新合约开始前一天，确保无缝衔接',
      'willImmediatelyContract': '若运价有效期是包含关系，旧合约结束时间提前至新合约开始前，新合约优先生效',
      'willDisableContracts': '系统检测到合约日期重叠时，禁用旧合约',
      'disableAutomaticCorrectionContracts': '关闭自动修正，人工修改重叠合约',
      'routeScheduleSettings': '船期设置',
      'newRouteCodeScheduleRules': '新增航线代码船期规则',
      'editRouteCodeScheduleRules': '编辑航线代码船期规则',
      'copyRouteCodeScheduleRules': '复制航线代码船期规则',
      'uniqueId': '唯一ID',
      'routeCodeConditions': '航线代码条件',
      'shippingScheduleReturnRulesPleaseSelectAnyOneRule': '船期返回规则（必填任一规则）',
      'exclude': '排除',
      'include': '包含',
      'pleaseSelectThePortDeparture': '请选择起运港',
      'pleaseSelectLeastOneShippingScheduleReturnOption': '请选择至少一个船期返回规则',
      'customTemplateImport': '定制模板导入',
      'afterImportingUploadList': '导入后，请在【上传列表】查看导入结果',
      'fareVersion': '运价版本'
    }
  },
  en: {
    'packageId': 1,
    'packageName': 'giga',
    'languageCode': 'en',
    'filedMap': {
      'markupManagement': 'Markup',
      'byPercentageBaseFreightTitle': 'By percentage(base freight)',
      'CarrierCode_IsNotEmpty_Exception': 'Carrier code cannot be empty',
      'freightCollectFeeTitle': 'Freight collect fee',
      'pleaseEnterSurchargeNamePrompt': 'Please enter a name for the surcharge',
      'unitTitle': 'Unit',
      'viewRatePeriodValidityTitle': 'View rate period validity',
      'pleaseEnterEnglishVesselPrompt': 'Please enter the vessel in English',
      'lineCategoryTitle': 'Line Category',
      'viewVersionValidityButton': 'View validity',
      'uploadingFileTitle': 'Uploading file',
      'ContainerSizeType_IsRequired_Exception': 'Container size type is required',
      'willBeReplacedDirectlyOnlytariffDataUploadWillBeRetainedPrompt': 'It will be replaced directly, and only the tariff data of this upload will be retained;',
      'commodityArrayTitle': 'Commodity',
      'operationSuccessPrompt': 'Operation success',
      'withinCollectionTitle': 'Within a collection',
      'FileName_IsRequired_Exception': 'File name is required',
      'CompanyId_IsRequired_Exception': 'Company id is required',
      'contractValidityPeriodExpireNoticeSevenDaysInAdvancePrompt': 'Contract validity expire(notice seven days In advance)',
      'approvalTitle': 'Reviewing',
      'rateFailureTimeTitle': 'Rate failure time',
      'continueListingButton': 'Continue to listing',
      'ListingProduct_NotExist_Exception': 'The item was not present at the time of listing',
      'notmatchComponentTypePrompt': 'There is no match to the component type',
      'normalTip': 'Please remember to maintain the price~',
      'contractManagementMenu': 'S/C',
      'rateInfoTitle': 'Rate info',
      'estimatedCostsTitle': 'Estimated costs',
      'blankSailingTip': 'If the shipping schedule status is changed to empty/suspended, Please confirm again whether to modify it?',
      'onlyFullyModifiedListedUnlistedInvalidatedFailedLaunchedStatusRateDataPrompt': 'Just support edit【Not put on/expiry/put on/put on failed】rate',
      'prebookingDetailMenu': 'Prebooking Detail',
      'notYetTitle': 'Not',
      'pageStripButton': 'Rates',
      'noOverlapTitle': 'No overlap',
      'refuseButton': 'Refuse',
      'CarrierCode_IsRequired_Exception': 'Carrier code is required',
      'routeTitle': 'Service',
      'addRateButton': 'Add Rate',
      'ProductSnapshotSigningFailed_Exception': 'Product snapshot signing failed',
      'rateTrendTitle': 'Rate trend',
      'fieldTypeIsEmptyPrompt': 'The field type is empty',
      'InterfaceErrorException': 'Interface call error',
      'yearlyTitle': 'Yearly',
      'shippingContainerVolume': 'Container volume',
      'pleaseSelectCarrierScheduleDataPrompt': 'Please select a shipment schedule data',
      'cutOpenTitle': 'Cut/open',
      'CompanyId_IsNotEmpty_Exception': 'Company id cannot be empty',
      'andTitle': 'And',
      'uploadRecordMenu': 'Upload Record',
      'variableDefinitionNotExistPrompt': 'The variable definition does not exist',
      'pleaseUploadFilePrompt': 'Please upload file',
      'FileInfoDTOList_IsNotEmpty': 'File List cannot be empty',
      'editNationalPortSurchargeTitle': 'Edit national port surcharge',
      'Quotation_data_cannot_be_queried': 'No quotation data was found',
      'remarkTitle': 'Remarks',
      'offlineTitle': 'Offline',
      'pleaseSelectTransitMethodPrompt': 'Please select a transit method',
      'textQuotationTitle': 'Text quotation',
      'overlappingProcessingTitle': 'Overlapping processing',
      'FileInformationIsAbnormalPleaseRegenerateTheQuotation_Exception': 'The file information is abnormal, please regenerate the quotation',
      'rateMiddlePlatform': 'Giga Rate',
      'ValidityPeriodFromValidTo_GreaterThan_Exception': 'The starting validity is greater than the end validity',
      'deleteCurrentContractDeleteAllRelatedProductPrompt': 'If this contract is deleted,all rate related to the contract will be deleted,Are you sure?',
      'copiedToClipboardPrompt': 'Copied to clipboard!',
      'loadingPortTitle': 'Loading Port',
      'addPriceMarkupRuleTitle': 'Add price markup rule',
      'freightCollectTotalTitle': 'Freight Collect Total',
      'LanguageResourceId_IsNotEmpty_Exception': 'Language resource id cannot be empty',
      'TimeOutErrorException': 'Network timeout',
      'QuotationPrices_NotExist_Delete_Exception': 'Quotation prices does not exist or has been deleted',
      'carrierSurchargeTitle': 'Carrier surcharge',
      'daysTitle': 'Days',
      'pushChannelsTitle': 'Push channels',
      'tenThousandTitle': 'Ten thousand',
      'quickQuotation': 'Quick Quotation',
      'exceptionDataLlineNumberTitle': 'Exception data (line number)',
      'onlySupportTitle': 'Only support',
      'startPointTitle': 'Start point',
      'notNullTitle': 'Not null',
      'nomarlTitle': 'Nomarl',
      'trainloadTitle': 'Trainload',
      'oceanShippingTitle': 'Ocean shipping',
      'searchButton': 'Search',
      'costPriceTitle': 'Net Cost',
      'NeedLoginException': 'No Login',
      'addFilterProjectButton': 'Add filter project',
      'releaseDateTitle': 'Release date',
      'confirmWantDeleteProductPrompt': 'Are you sure you want to delete your listing?',
      'isNullTitle': 'Is null',
      'addTagButton': 'Add Tag',
      'railwayTitle': 'Railway',
      'ExistSameListedStatusProducts_Exception': 'There are products with the same listed status',
      'pleaseEnterKeywordFieldPrompt': 'Please enter a keyword',
      'cancelButton': 'Cancel',
      'disableButton': 'Forbidden',
      'clearLabels': 'Clear labels (manual)',
      'passedTitle': 'Passed',
      'importRateButton': 'Import Rate',
      'manualAssociation': 'Manual association',
      'Content_IsRequired_Exception': 'The text quote content cannot be empty',
      'parsingPrompt': 'Parsing',
      'QuotationPrices_AlreadyExists_Exception': 'Quotation prices already exists',
      'expectedRiseTitle': 'Expected rise',
      'rateMiddleOfficeMenu': 'Giga Rate',
      'estimateDeliveryDateTitle': 'ETD',
      'quotationContent': 'Quotation Content',
      'quotationTimeTitle': 'Quotation Time',
      'RateInfo_AlreadyExists_Exception': 'Rate info already exists',
      'inlandPointTitle': 'Inland',
      'contractDetailMenu': 'Contract Detail',
      'pleaseTickFilterDataProceedPrompt': 'Please tick or filter the data to proceed',
      'pleaseSelectValidityRangePrompt': 'Please select a validity range',
      'operationStatusTitle': 'Operation Status',
      'noDataMatchedPrompt': 'No data is matched',
      'pleaseSelectSurchargeTypePrompt': 'Please select a surcharge type',
      'selectAllTitle': 'Select All',
      'deleteButton': 'Delete',
      'rateRemarksTitle': 'Rate Remarks',
      'wednesdayTitle': 'Wed',
      'Schedule_IsNotEmpty_Exception': 'Schedule cannot be empty',
      'remarksInfoTitle': 'Remarks info',
      'fullShelfButton': 'Show All',
      'CoordinatorIds_IsRequired_Exception': 'Coordinator id is required',
      'estimatedArrivalScheduleTitle': 'Estimated arrival schedule',
      'createContainerSizeTypeButton': 'Create container size type',
      'pleaseSelectSchedulePrompt': 'Please select a schedule',
      'toBeResolvedTitle': 'To be resolved',
      'latestVersionTitle': 'Latest Version',
      'reviewTheOverlapTitle': 'Review the overlap',
      'notInCollectionTitle': 'Not in a collection',
      'continueTakeDownButton': 'Continue to take down',
      'doorToDoorTitle': 'CY/CY',
      'rateTypeTitle': 'Rate type',
      'UserBranchCompany_IsNotEmpty_Exception': 'The branch office to which the user belongs cannot be empty',
      'enabledTitle': 'Enabled',
      'freightForwardingSurchargeMenu': 'Freight forwarding surcharge',
      'lineHeightButton': 'Line Height',
      'contractOwnerTitle': 'Contract owner',
      'Schedule_IsRequired_Exception': 'Schedule is required',
      'transferPointTitle': 'Transfer point',
      'LanguageResourceType_IsNotEmpty_Exception': 'Language resource type ',
      'uploadingFilesPleaseLaterPrompt': 'Uploading files, please later...',
      'editContractRateTitle': 'Edit S/C Rate',
      'meetConditionTitle': 'Meet condition',
      'contractCountTitle': 'Contract count',
      'UserId_IsNotEmpty_Exception': 'User id cannot be empty',
      'PorIds_IsRequired_Exception': 'Por id is required',
      'pageButton': 'Page',
      'syncSurchargesInfoPrompt': 'Sync surcharges info',
      'typeTitle': 'Type',
      'fieldNameIsEmptyPrompt': 'The field name is empty',
      'companyAddressTitle': 'Company address',
      'unlockTitle': 'Unlock',
      'LanguagePackage_IsNotExist_Exception': 'Language package does not exist',
      'QuotationNum_IsRequired_Exception': 'The quotation No. cannot be empty',
      'ContractInfo_NotExist_Delete_Exception': 'The contract does not exist or has been deleted',
      'bulkEnableButton': 'Batch enable',
      'cancelFilterButton': 'Cancel Filter',
      'thisOperationWillListAllUnlistedDataAfterFilteringPleaseCheckAgainPrompt': 'This operation will list all unlisted data after filtering, please check again',
      'bySpecificAmountTitle': 'By specific amount',
      'confirmWantDeleteRulePrompt': 'Are you sure you want to delete the rule?',
      'checkDataMissingMandatoryAutomaticPrompt': 'Check data missing mandatory automatic（line No.）',
      'MakeQuotationsTitle': 'Make quotations',
      'downtimeTitle': 'Downtime',
      'blueTitle': 'Blue',
      'freightCollectFeeTotalTitle': 'Freight collect fee total',
      'summaryTitle': 'Summary',
      'generateQuoteButton': 'Generate a quote',
      'saveAsButton': 'Save As',
      'supportedStatus': "Only freight data with associated status of 'listed/not listed/failed to list' is supported",
      'contactTitle': 'Contact',
      'nationalPortSurchargeTitle': 'National port surcharge',
      'scenarioNameAlreadyExistsPrompt': 'The scenario name already exists',
      'rejectedTitle': 'Rejected',
      'pleaseEnterDestinationPortPrompt': 'Please enter the destination port',
      'modifyCopyText': 'You can modify/copy the following text to quickly quote',
      'ContainerSizeType_IsNotEmpty_Exception': 'Container size type cannot be empty',
      'RpcErrorException': 'Rpc error',
      'zeroTitle': 'Zero',
      'confirmWantRemoveProductPrompt': 'Are you sure you want to remove your product?',
      'notMatchedPortLineNumberPrompt': 'Not matched to port (line number)',
      'updateTimeTitle': 'Update time',
      'detailTitle': 'Detail',
      'tagCodeTitle': 'Tag code',
      'contractDetailTitle': 'Contract detail',
      'loadMoreDataTitle': 'Load more data',
      'confirmWantToBatchDeletePrompt': 'Are you sure you want to batch delete?',
      'otherTitle': 'Other',
      'ContainerSizeType_IsRepeated_Exception': 'The container type cannot be repeated',
      'addSurchargeRuleButton': 'Add surcharge rule',
      'versionNoTitle': 'Version No.',
      'exportFreeTimeTitle': 'Export free time',
      'LanguagePackage_IsNotNull_Exception': 'The language pack does not',
      'pleaseSelectBillingUnitPrompt': 'Please select a billing unit',
      'addScheduleButton': 'Add Schedule',
      'submitFailedTitle': 'Submit failed',
      'addFederationConditionTitle': 'Add a federation condition',
      'LineCode_IsRequired_Exception': 'Line code is required',
      'confirmWantPassPrompt': 'Are you sure you want to pass?',
      'onlyFullyModifiedUnlistedFailedStatusPrompt': 'Just support edit【Not put on/put on failed/Expired】rate',
      'nationalPortSurchargeMenu': 'National port surcharge',
      'isLockedTitle': 'Lock or not',
      'DestinationId_IsRequired_Exception': 'Destination id is required',
      'portOfDischargeTitle': 'POD',
      'LanguageName_IsNotEmpty_Exception': 'The language name cannot be empty',
      'SelectedContractHasRelatedProduct_OperationInvalid_Exception': 'The selected contract has related product and the operation is invalid',
      'pleaseDeleteTheRelevantRatesManagementBeforeDeletingTheContractPrompt': 'Please delete the relevant freight rates in the freight management before deleting the contract',
      'pleaseTickSurchargePrompt': 'Please tick surcharge',
      'dateValuePrompt': 'Date value',
      'pleaseSelectContainerTypeOrRatePrompt': 'Please select the container type or rate',
      'RateAlreadyExistPleaseEditTheBasicInformationOrSailingScheduleInformationAgain_Exception': 'Tariffs already exist, please edit the basic information or sailing schedule information again',
      'ModifyMarkupRuleFailed_Exception': 'Modify markup rule failed',
      'chineseNameTitle': 'Chinese name',
      'confirmWantDisableCurrentContractPrompt': 'Are you sure you want to disable the current contract?',
      'saveButton': 'Save',
      'destinationPortFeeTitle': 'Destination port Fee',
      'standardContainerTitle': 'Standard container',
      'baseFreightTitle': 'Base freight',
      'compactButton': 'Compact',
      'OperatorParams_NotExist_Exception': 'Operator params does not exist',
      'loadingPortFeesTitle': 'Loading Port Fees',
      'notListedPrompt': 'Not listed',
      'ProductInfo_NotListed_Exception': 'Product info not listed',
      'expectedDeclineTitle': 'Expected decline',
      'isAllIn': 'Is ALL IN',
      'pageOfButton': 'Total',
      'rateTotalTableMenu': 'Rate Total',
      'rateRecordsMenu': 'Rate Change Records',
      'rateRecordsDetails': 'Rate Change Details',
      'otherRemarksTitle': 'Remarks',
      'rateNewRemarksTitle': 'Freight Remarks',
      'monthTitle': 'Month',
      'addInlandFreightsTitle': 'Add inland freights',
      'clickMetoCopy': 'Click me to copy',
      'branchManagementMenu': 'Branch management',
      'feeNameTitle': 'Fee name',
      'periodValidityTitle': 'Period validity',
      'checkBoxTitle': 'Check the box',
      'editSurchargeTitle': 'Edit the surcharge',
      'contractImportTemplateButton': 'Contract import template',
      'approvalStatusTitle': 'Audit Status',
      'ContactNameTitle': 'Name',
      'bulkDeleteButton': 'Batch delete',
      'downloadImportTemplateButton': 'Download the import template',
      'ContractInfo_AlreadyExists_Exception': 'The contract already exists',
      'containerCostMenu': 'Container Cost',
      'expiryDateTitle': 'Expiry date',
      'closeButton': 'Close',
      'editFilterProjectButton': 'Edit filter project',
      'guidTitle': 'Guid',
      'User_NotExist_Exception': 'User not exist',
      'dockTitle': 'Dock',
      'resetSortTitle': 'Reset sort',
      'pushContentTitle': 'Push content',
      'freightPrepaidFeeTotalTitle': 'Freight prepaid fee total',
      'rateResolvedTitle': 'Rate resolved',
      'effectiveDateTitle': 'Effective date',
      'listTitle': 'List',
      'surchargeRuleDetailMenu': 'Surcharge rule detail',
      'dataAuthorityManagementMenu': 'Data authority management',
      'costPriceBaseFreightTitle': 'Net Cost(base freight)',
      'mondayTitle': 'Mon',
      'QuotationPrices_NotExist_Exception': 'Quotation prices does not exist',
      'pleaseSelectContainerTypePrompt': 'Please select the container type',
      'pleaseEnterMaximumWeightPrompt': 'Please enter the maximum weight',
      'viewButton': 'View',
      'eCommerceRateMenu': 'Spot',
      'associatedLabels': 'Associated labels',
      'businessTypeTitle': 'Business Type',
      'pleaseWaitWhileTheDataLoadsPrompt': 'Please wait while the data loads',
      'ticketTitle': 'Bill',
      'OperationType_IsNotEmpty_Exception': 'Operation type cannot be empty',
      'tagManagement': 'Tag',
      'portSurchargeMenu': 'Port Surcharge',
      'confirmWantDisassociatePrompt': 'Are you sure you want to disassociate?',
      'coinTitle': 'Currency',
      'prebookingMenu': 'Prebooking',
      'exceptCurrentContactAllProductsRelatedContractDeletedContinueToBeDeletedPrompt': 'If this contract is deleted,all rate related to the contract will be deleted,Are you sure?',
      'freightPrepaidCollectTitle': 'P/C',
      'PleaseDeleteRelevantRateInRateManagementBeforeDeletingContract_Exception': 'Please delete the relevant rate in rate Management before deleting the contract',
      'rateStatusTitle': 'Rate status',
      'sundayTitle': 'Sun',
      'rateAutomaticPutOffNoticePrompt': 'Rate automatic put off notice',
      'dayTitle': 'Day',
      'afterUnlockingRematchConfirmPrompt': 'After unlocking, the rematch rule will import data, please confirm whether to unlock it?',
      'fullTitle': 'Full',
      'StartingPointId_IsRequired_Exception': 'Starting point id is required',
      'startDateTitle': 'Start date',
      'editFreightForwardingSurchargeTitle': 'Edit a freight forwarding surcharge',
      'TicketCost_IsRequired_Exception': 'Ticket cost is required',
      'detailSummaryTitle': 'Detail summary',
      'addSurchargeButton': 'Add Surcharge',
      'closeBillScheduleTitle': 'Cut Off Voyage',
      'ruleImportButton': 'Rule import',
      'departureDayTitle': 'Departure date',
      'editValidityPeriodTitle': 'Edit validity',
      'addChargeDetailTitle': 'Add charge detail',
      'unloadingPointTitle': 'Unloading point',
      'pleaseRefreshAndViewLater': 'Label data processing in progress, please refresh and view later',
      'porTitle': 'POR',
      'transferTitle': 'Transfer',
      'parsingSuccessPrompt': 'Parsing success',
      'pleaseEnterRemarks': 'Remarks',
      'confirmWantDisableSurchargeDetailPrompt': 'Are you sure you want to disable surcharge detail?',
      'rateDetailMenu': 'Rate Detail',
      'VersionNo_AlreadyExists_Exception': 'Version no already exists',
      'directTitle': 'Direct',
      'YanXuanChannelStatusTitle': 'YanXuan Channel Status',
      'prebookingRemarkTitle': 'Prebooking remarks',
      'continueTitle': 'Continue',
      'OperationType_NotExist_Exception': 'Operation type not exist',
      'ContainerCost_NotExist_Exception': 'The container cost not exist',
      'pleaseEnterFeePrompt': 'Please enter the fee',
      'characterTextBoxPrompt': 'Character text box',
      'Failed_To_Generate_Quotation': 'Failed to generate the quotation',
      'contractTypeTitle': 'Contract type',
      'addDischargePointButton': 'Add a discharge point',
      'historicalSearch': 'Historical search',
      'priceDetailTableMenu': 'Price detail table',
      'addOfflineRateButton': 'Add offline rate',
      'ssociationType': 'Association type',
      'takeTitle': 'Take',
      'importExportTitle': 'Import/Export',
      'addNationalPortSurchargeTitle': 'Add national port surcharge',
      'productHasBeenRemovedPrompt': 'The product has been removed',
      'pleaseSelectImportExportTypePrompt': 'Please select the import/export type',
      'TokenGetFailed_Exception': 'Token acquisition failed',
      'managementSideTitle': 'Management',
      'confirmWantToPrompt': 'Be sure you want to',
      'fileTitle': 'File',
      'replaceTitle': 'Replace',
      'commodityDetailTitle': 'Commodity Detail',
      'Quotation_Data_Invalid_Exception': 'The data used to generate the quote is invalid',
      'englishNameTitle': 'English name',
      'yearTitle': 'Year',
      'podTitle': 'POD',
      'confirmWantApprovalPassPrompt': 'Are you sure you want to pass the review?',
      'descendingSortTitle': 'Desc',
      'checkNormadate': "Please check the 'Normal' data for the shipping schedule status!",
      'rateValidityPeriodExpireNoticeOneDaysInAdvancePrompt': 'Rate validity expire(notice one days in advance)',
      'uploadedFreightRateHistoricalFreightRateDataWillBeRetainedPrompt': 'The uploaded freight rate and historical freight rate data will be retained;',
      'lockedButton': 'Lock',
      'confirmEditButton': 'Confirm Edit',
      'vesselTitle': 'Vessel',
      'rateImportTemplateTitle': 'Rate import template',
      'orThisTitle': 'Or',
      'transitTimeTitle': 'Transit time',
      'bulkButton': 'Batch operation',
      'PolId_IsNotEmpty_Exception': 'Pol id cannot be empty',
      'editCarrierSurchargeTitle': 'Edit carrier surcharge',
      'ListingFailed_Exception': 'Listing failed',
      'followingConditionsAutomaticallyMatchedRatePrompt': 'If the following conditions are met, the tariff information will be automatically matched',
      'rateSourceTitle': 'Rate Source',
      'pleaseSelectPushChannelPrompt': 'Please select a push channel',
      'editDetailTitle': 'Edit detail',
      'TenantId_IsNotEmpty_Exception': 'Tenant id cannot be empty',
      'yourConfirmPrompt': 'Your confirm',
      'TransportationType_IsRequired_Exception': 'Transportation type is required',
      'SelectDisabledData_Exception': 'Please select [Disabled] data',
      'uploadStatusTitle': 'Upload Status',
      'pleaseSelectDeparturePortTerminalPrompt': 'Please select the pol tml',
      'editInlandFreightsTitle': 'Edit inland freights',
      'SurchargeName_IsRequired_Exception': 'Surcharge name is required',
      'pleaseAddContainerTypePrompt': 'Please add a box type',
      'weekTitle': 'Week',
      'ProductSnapshotCreateFailed_Exception': 'Product snapshot creation failed',
      'authorityMenu': 'Authority',
      'rateRepetitionTitle': 'Rate repetition',
      'loadECommerceDataTitle': 'Load e-commerce data',
      'ValidityPeriod_DataException_Exception': 'Validity period data exception',
      'coverHistoricalFreightRatesTitle': 'Cover historical freight rate',
      'allProjectButton': 'All',
      'defaultConditionsDisplayedPrompt': 'The conditions that are displayed by default',
      'pleaseSelectTableWithStandardRowColumnDataPrompt': 'Please select a table with standard row and column data,',
      'saturdayTitle': 'Sat',
      'inlandFreightMenu': 'Inland Freight',
      'inlandFreightMenuNew': 'Inland',
      'carrierTitle': 'Carrier',
      'overlapHandledTitle': 'The overlap is handled',
      'estimateArrPortDateTitle': 'ETA',
      'noDataYetPrompt': 'No data yet',
      'freightTitle': 'Freight',
      'importTitle': 'Import',
      'overlapTitle': 'Overlap',
      'successRateTitle': 'Success rate',
      'bulkImportContractInfoTitle': 'Bulk import contract info',
      'serviceMaintainTitle': 'Service maintain',
      'riseTitle': 'Rise',
      'inCabinSystemTitle': 'In-cabin system',
      'quotationTypeTitle': 'Quotation type',
      'validityPeriodTitle': 'Validity',
      'contractImportButton': 'Contract import',
      'ContainerPrice_IsRequired_Exception': 'Container price is required',
      'MarkupRule_NotExist_Exception': 'Markup rule not exist',
      'associateLabelFunction': "You can associate labels through the 'Associate Label Function' in the freight rate",
      'ruleCodeTitle': 'Rule code',
      'pleaseEnterNameForTheFeePrompt': 'Please enter a name for the fee',
      'ImportFileContentAbnormalException_Exception': 'The contents of the import file are abnormal',
      'addCabinProtectionButton': 'Create Cabin Protection',
      'newButton': 'Create',
      'pleaseSelectCurrencyPrompt': 'Please select a currency',
      'confirmWantEnableProductPrompt': 'Are you sure you want to enable your product?',
      'rateEffectiveTimeTitle': 'Rate effective time',
      'downloadFailedTitle': 'Download failed',
      'LackTokenUnableToQueryOnlineRates_Exception': 'Lack of token, unable to query online freight rates',
      'portTitle': 'Port',
      'addSurchargeTitle': 'Add surcharge',
      'cabinProtectionInfoTitle': 'Cabin protection info',
      'chargeTypeTitle': 'Charge Type',
      'Carrier_NotExist_Exception': 'Carrier not exist',
      'ValidityPeriodRange_IsRequired_Exception': 'Validity range is required',
      'transferPointChargeMenu': 'Transfer point charge',
      'realtimeScheduleTitle': 'Realtime schedule',
      'ContractType_IsRequired_Exception': 'Contract type is required',
      'distributionSystemCodeTitle': 'Distribution system code',
      'copyButton': 'Copy',
      'createrTitle': 'Creator',
      'transitTimeDayTitle': 'Transit time(day)',
      'thousandTitle': 'Thousands',
      'ascendingSortTitle': 'Asc',
      'uploadedDatetimeTitle': 'Uploaded datetime',
      'pleaseEnterDeparturePortTerminalPrompt': 'Please enter the pol tml',
      'editAllButton': 'Edit All',
      'selectRouteCodePrompt': 'Select a service',
      'LineCategoryId_IsRequired_Exception': 'Line category id is required',
      'PageSize_IsNotEmpty_Exception': 'Page size cannot be empty',
      'distributionDetailMenu': 'Distribution Detail',
      'addFreightForwardingSurchargeTitle': 'Add a freight forwarding surcharge',
      'demurrageContainerChargeTitle': 'Demurrage container charges',
      'tagStatusTitle': 'Tag status',
      'distributionManagementMenu': 'Distribution',
      'statusTitle': 'Status',
      'rateImportButton': 'Rate import',
      'pleaseEnterPortDeparturePrompt': 'Please enter the port of departure',
      'confirmButton': 'Confirm',
      'inquiryTitle': 'Inquiry',
      'rateHistoryRecordTitle': 'Rate history record',
      'createTimeTitle': 'Create time',
      'thePortIsNotMatchedPrompt': 'The port is not matched（line No.）',
      'continueDeleteButton': 'Continue delete',
      'suggestDisableButton': 'Suggest disable',
      'surchargeNameTitle': 'Surcharge Name',
      'contractStatusTitle': 'Contract status',
      'SurchargeId_IsRequired_Exception': 'Surcharge id is required',
      'pleaseConfirmExportInfoPrompt': 'Please confirm export info',
      'downloadImportFailedDataTitle': 'Download import failed data',
      'historicalTariffsAreNotCoveredTitle': 'Historical tariffs are not covered',
      'destinationPortWithContainerFreeMenu': 'Destination port with container free',
      'pleaseEnterStartingPointPrompt': 'Please enter a starting point',
      'pleaseEnterPrompt': 'Please enter ',
      'validityPeriodEndDateTitle': 'EXPDATE',
      'PodId_IsNotEmpty_Exception': 'Pod id cannot be empty',
      'confirmWantDeleteCurrentTagPrompt': 'Are you sure you want to delete the current tag?',
      'bulkImportRateInfoTitle': 'Bulk import rate info',
      'tariffDataSameCarrierContractNumberAlreadyExistsSystemPrompt': 'If the tariff data of the same carrier and contract number already exists in the system,',
      'shippingScheduleInfoTitle': 'Schedule info',
      'numberTextFieldTitle': 'Number Text Field',
      'bulkPutOffButton': 'Batch put off',
      'PortId_IsRequired_Exception': 'Port id is required',
      'CoordinatorIds_IsNotEmpty_Exception': 'Coordinator id cannot be empty',
      'dataLoadingPrompt': 'Data loading...',
      'guideAskPriceIsDisplayedAsTheBaseFreightPrompt': 'The guide ask price is displayed as the base freight',
      'freeDemurrageTitle': 'DND',
      'cellPhoneNoTitle': 'Cell-phone No.',
      'pleaseSelectCarrierSchedulePrompt': 'Please select a shipment schedule',
      'ContainerCost_IsNotEmpty_Exception': 'Container cost cannot be empty',
      'confirmWantEnableCurrentContractPrompt': 'Are you sure you want to enable the current contract?',
      'demurragePortChargeTitle': 'Demurrage port charges',
      'IsInclude_IsNotEmpty_Exception': 'Whether or not to include the total price cannot be empty',
      'Full_OperationFailed_Exception': 'Full operation failed',
      'File_GenerateFailed_Exception': 'File generate failed',
      'updaterTitle': 'Updater',
      'editOfflineRatesTitle': 'Edit offline rate',
      'customizationTitle': 'Customization',
      'BaseInfo_IsNotEmpty_Exception': 'Base info cannot be empty',
      'justSupportTitle': 'Just support',
      'flightScheduleTitle': 'Flight schedule',
      'ContractId_IsRequired_Exception': 'Contract id is required',
      'hotRateButton': 'Hot rate',
      'disabledTitle': 'Disabled',
      'defaultConditionTitle': 'Default Condition',
      'directTransferTitle': 'Direct/Transfer',
      'chargeStepTitle': 'Charge Step',
      'addButton': 'Add',
      'FileBeingGeneratedPleaseTryAgainLater_Exception': 'The file is being generated, please try again later',
      'youCanPrompt': 'you can',
      'WrongParamsException': 'Parameter parsing error',
      'departmentAuthorityManagementMenu': 'Department authority management',
      'moreConditionsButton': 'More Filter Selections',
      'importFreeTimeTitle': 'Import free time',
      'distributionGoesOfflineMenu': 'Distribution goes offline',
      'containerTitle': 'Container',
      'distributionSystemTitle': 'Distribution system',
      'arrPortDateTitle': 'Arrival port date',
      'confirmWantEnableSurchargeDetailPrompt': 'Are you sure you want to enable surcharge detail?',
      'chargeTitle': 'Fee',
      'ImportRecord_NotExist_Exception': 'The import record does not exist',
      'pleaseSelectRouteCodePrompt': 'Please select the service',
      'supplierTitle': 'Supplier',
      'ContractInfo_NotExist_Exception': 'The contract does not exist',
      'SnapshotDigestSigningFailed_Exception': 'Snapshot digest signing failed',
      'fulfillingTitle': 'Fulfilling',
      'PodId_IsRequired_Exception': 'Pol id is required',
      'arrivalScheduleTitle': 'Arrival Schedule',
      'priceValidityPeriodTitle': 'Validity',
      'shipownerRuleTitle': 'Shipowner rules',
      'ValidityPeriod_DataException': 'Validity data exception',
      'copyRateTitle': 'Copy Rate',
      'pleaseEnterCountryPrompt': 'Please enter a country',
      'PackageName_IsNotEmpty_Exception': 'Language package cannot be empty',
      'addContractTitle': 'Add contract',
      'editTagButton': 'Edit Tag',
      'spaceStatusTitle': 'Space Status',
      'radioTitle': 'Radio',
      'manualOfflineTitle': 'Manual offline',
      'operateTitle': 'Operate',
      'offlineRateMenu': 'Offline Rate',
      'PaymentMethod_IsNotEmpty_Exception': 'Payment method cannot be empty',
      'containerTypeHasBeenDuplicatedPleaseSelectAgainPrompt': 'Container type has been duplicated, please select it again',
      'changeGuideSalePriceButton': 'Change suggest selling',
      'FullPutOff_OperationFailed_Exception': 'Full put off operation failed',
      'IsInclude_IsRequired_Exception': 'Required to include in the total price',
      'selectDistributionReleaseDataTitle': 'Select Distribution release data',
      'putOffButton': 'Put Off',
      'containerTypefreightTitle': 'Freight',
      'contractParsingTitle': 'Contract resolved',
      'Page_IsNotEmpty_Exception': 'Page cannot be empty',
      'onlyUpToFourBoxTypesCanBeSelectedPrompt': 'Only up to four box types can be selected',
      'QuotationInfoList_IsNotEmpty_Exception': 'The quotation info used for quick quote cannot be empty',
      'basicInfoTitle': 'Basic info',
      'remainTitle': 'Remain',
      'pleaseEnterContainerCostPrompt': 'Please enter the contract cost',
      'surchargeEnNameTitle': 'Surcharge english name',
      'PdlIds_IsRequired_Exception': 'Pdl id is required',
      'otherFreeTitle': 'Other free',
      'entrySalesPointMenu': 'Enter sales interface',
      'pleaseEnterThePrebookingRemarksOptionalPrompt': 'Please enter the prebooking remarks (optional)',
      'destinationPortFeesTitle': 'Destination Port fees',
      'automaticOfflineTitle': 'Automatic offline',
      'PaymentMethod_IsRequired_Exception': 'Payment method is required',
      'pleaseEnterQueryFieldPrompt': 'Enter Item Name to Search',
      'pleaseSelectDistributionSystemPrompt': 'Please select a Distribution system',
      'NoTitle': 'No',
      'associatedSurchargesButton': 'Associated surcharges',
      'selectScheduleButton': 'Select schedule',
      'pleaseEnterRulePriorityPrompt': 'Please enter the rule priority',
      'selectLabel': 'Please select a label',
      'SurchargeName_IsNotEmpty_Exception': 'The surcharge name cannot be empty',
      'markupInfoFollowsFreightCurrencyPrompt': 'Then the markup information is as follows: (The currency system uses the basic freight currency system corresponding to the tariff information)',
      'exportSelectedDataButton': 'Export selected data',
      'endDateTitle': 'End date',
      'FileId_IsRequired_Exception': 'File id is required',
      'Commodity_IsNotEmpty_Exception': 'Commodity cannot be empty',
      'dragTheFileHereTitle': 'Drag the file here',
      'createDetailButton': 'Create detail',
      'scheduleDataTitle': 'Schedule data',
      'pleaseSelectModifyDatePrompt': 'Please select a modification date',
      'selectContainerTypeHasBeenDuplicatedPleaseSelectAgainPrompt': 'Select the container type has been duplicated, please select it again',
      'addContractRateTitle': 'Add contract rate',
      'contractTitle': 'Contract',
      'soldOutTitle': 'Sold out',
      'uploadDateTitle': 'Upload date',
      'IncludedInTheTotalCostTheFeeIsNoLongerCalculatedPrompt': 'Included in the total cost, the fee is no longer calculated',
      'saveQuoteButton': 'Save',
      'DataSource_IsNotEmpty_Exception': 'The data source cannot be empty',
      'chargeSourceTitle': 'Charge Source',
      'lineCodeTitle': 'Service',
      'redTitle': 'Red',
      'syncResourceInfoPrompt': 'Sync resource info',
      'weightLimitKgTitle': 'Weight limit(KG)',
      'myQuotationMenu': 'Quotation',
      'enableButton': 'Enable',
      'needToBeChargedAdditionally': 'The following fees are not included in the total fees and [need] to be charged additionally;',
      'alreadyTitle': 'Already',
      'ofPortsOfCallTitle': 'of ports of call',
      'home': 'Home',
      'pleaseEnterNoteHigherValuePrompt': 'Please enter, Note: The higher the value, the more executed first',
      'enterManagementInterfaceMenu': 'Maintainance\n',
      'maximumWeightTitle': 'Maximum weight',
      'afterLockingCurrentRateDataNotBeMatchDataAffectedSupportCustomDataPrompt': 'After locking, this tariff data will not be affected by the matching data and support custom data',
      'ContractNo_IsRequired_Exception': 'Contract No is required',
      'doNotRequireAdditionalCharges': 'The following fees have been included in the total fee and [do not require] additional charges',
      'singleQuoteTitle': 'Single quote',
      'hundredsTitle': 'Hundreds',
      'SystemErrorException': 'System error',
      'pleaseSelectChargeTypePrompt': 'Please select a fee type',
      'tagNameTitle': 'Tag name',
      'surchargeTypeTitle': 'Surcharge type',
      'ContractInfo_AlreadyExists': 'The contract already exists',
      'containerTypeCostTitle': 'Container type cost',
      'polDockTitle': 'POL TML',
      'fullScreenTitle': 'Full screen',
      'baseFieldTitle': 'Base field',
      'Commodity_IsRequired_Exception': 'Commodity is required',
      'editSurchargeRuleTitle': 'Edit the surcharge rule',
      'quotationNo': 'Quotation no',
      'GeekYumYanXuanTitle': 'GeekYum YanXuan',
      'rateTitle': 'Rate',
      'pleaseEnterRuleNamePrompt': 'Please enter a rule name',
      'SnapshotSigningFailed_Exception': 'Snapshot signing failed',
      'exitFullScreenTitle': 'Esc exit full screen mode',
      'defaultCurrentDayDateDisplayedPrompt': 'The current days date is displayed by default and can be selected',
      'Data_IsRepeated_Exception': 'Data cannot be repeated',
      'orTitle': 'Or',
      'theSelectedFieldTitle': 'The selected field',
      'confirmWantDisableRulePrompt': 'Are you sure you want to disable the tag?',
      'quitMenu': 'Exit',
      'fullDeleteButton': 'Reset',
      'pleaseEnterContentPrompt': 'Please enter the content',
      'pleaseSelectContractTypePrompt': 'Please select the contract type',
      'ChargeUnit_IsNotEmpty_Exception': 'Charge Unit cannot be empty',
      'eCommerceTitle': 'Spot',
      'markupModeTitle': 'Markup Mode',
      'guideSalePriceIsNotEmptyPrompt': 'Suggest selling is not empty',
      'looseButton': 'Loose',
      'emptyTitle': 'Empty',
      'freightForwardingSurchargeTitle': 'Freight forwarding surcharge',
      'bulkDisableButton': 'Batch forbidden',
      'commoditySingleTitle': 'Commodity',
      'deleteAllButton': 'Delete All',
      'experienceRecommendedTheFullOperationDataWithinTwentyThousandPrompt': 'For your experience, it is recommended that you control the full operation data within 20,000',
      'weightLimitTitle': 'Weight limit',
      'RuleName_AlreadyExists_Exception': 'Rule name already exists',
      'enterpriseWeChatTitle': 'Enterprise WeChat',
      'BulkEditCanOnlyOperateOnUnlistedProducts_Exception': 'Bulk edit can only operate on unlisted products',
      'smsTitle': 'Sms',
      'contactUsTitle': 'Contact us',
      'lockedAfterTitle': 'Lock after',
      'saveFilterProjectButton': 'Save filter project',
      'autoAssociation': 'Auto association',
      'costOfPriceTitle': 'Net Cost',
      'ZaiCangChannelStatusTitle': 'ZaiCang Channel Status',
      'priorityRulesTitle': 'Priority of rules',
      'previewTitle': 'Preview',
      'pleaseEnterContainerTypePrompt': 'Please enter the contract type',
      'declineTitle': 'Decline',
      'pleaseEnterMinimumWeightPrompt': 'Please enter the minimum weight',
      'startMatchingRateRulesAndTagsPrompt': 'Start matching rate rules and tags',
      'submitSuccessTitle': 'Submit success',
      'scheduleTitle': 'Voyage',
      'thursdayTitle': 'Thurs',
      'defaultCurrentDayDisplayedCanChooseViewDataUploadedPreviousDatePrompt': 'By default, todays date is displayed, and you can choose to view the data uploaded on a previous date',
      'chargeStatusTitle': 'Charge status',
      'pleaseKeepOneConditionPrompt': 'Please keep one condition',
      'etaTitle': 'ETA',
      'detailsTitle': 'Details',
      'ApplicationErrorException': 'Application error',
      'SurchargeCategory_IsRequired_Exception': 'Surcharge category is required',
      'totaStockTitle': 'Stock',
      'keywordTitle': 'Keyword',
      'paymentMethodTitle': 'Payment method',
      'useConditionTitle': 'Use of condition',
      'freightPrepaidFeeTitle': 'Freight prepaid fee',
      'exportTitle': 'Export',
      'outletRateButton': 'Promotion',
      'pleaseSelectValidityPrompt': 'Please select a validity',
      'carrierSurchargeMenu': 'Carrier surcharge',
      'pleaseTickDataPrompt': 'Please tick data',
      'editContractTitle': 'Edit Contract',
      'QuotationPricesId_IsNotEmpty_Exception': 'Quotation Prices id cannot be empty',
      'QuotationPrice_IsNotEmpty': 'The total price of the quotation cannot be empty',
      'fileNameTitle': 'File Name',
      'pleaseSelectBusinessTypePrompt': 'Please select a business type',
      'pleaseEnterSupplierPrompt': 'Please enter a supplier',
      'collapseTitle': 'Collapse',
      'tagAlreadyExistsPrompt': 'Tag already exists',
      'resetButton': 'Reset',
      'confirmWantDisableCurrentTagPrompt': 'Are you sure you want to disable the current tag?',
      'priceColorTitle': 'Rate color',
      'whetherTitle': 'Whether',
      'containerYardFreetimeTitle': 'Container yard freetime',
      'ProductInfo_NotExist_Delete_Exception': 'The product does not exist or has been deleted',
      'pleaseEnterKeywordPrompt': 'Please enter a keyword',
      'distributionReleaseMenu': 'Distribution release',
      'PolId_IsRequired_Exception': 'Pol id is required',
      'equalsTitle': 'Equals',
      'AppActionErrorException': 'Application error,to control client behavior',
      'fullOperationTitle': 'Full operation',
      'currencyTitle': 'Currency',
      'varietyContainerTitle': 'Variety of container',
      'pleaseAddContainerTypeAccordingMarkupModelPrompt': 'Please add the container type according to the markup model',
      'clickUploadButton': 'Click Upload',
      'AddMarkupRuleFailed_Exception': 'Add markup rule failed',
      'initializeRateInfoPrompt': 'Initialize rate info',
      'BulkOperationsCanOnlyBePerformedWithDataFromDisabledFulfilledContracts_Exception': 'Bulk operations can only be performed with data from disabled and fulfilled contracts',
      'Currency_IsRequired_Exception': 'Currency is required',
      'pdlTitle': 'PDL',
      'IsAllInCalculate_IsRequired_Exception': 'Required to participate in ALL IN calculation',
      'releaseSuccessTitle': 'Release success',
      'pleaseEnterTagNamePrompt': 'Please enter a tag name',
      'shippingCancellationTitle': 'SPND',
      'clickEnterTitle': 'Click enter',
      'containerYardChargeTitle': 'Container yard charge',
      'ScheduleData_IsRepeated_Exception': 'Schedule data cannot be repeated',
      'ValidityPeriod_IsNotEmpty_Exception': 'Validity range cannot be empty',
      'emailTitle': 'Email',
      'stripRateTitle': 'Strip rate',
      'selectedFieldsTitle': 'Selected fields (drag-and-drop sorting)',
      'pleaseEnterDestinationTitle': 'Destination',
      'ContainerPrice_IsNotEmpty_Exception': 'Container price cannot be empty',
      'estimatedDepartureScheduleTitle': 'Estimated departure schedule',
      'CurrentContractExistProductBindingPleaseNotModifyContractNoCarrier_Exception': 'There is a product binding under the current contract, please do not modify the contract number and carrier',
      'conditionTitle': 'Condition',
      'podDockTitle': 'POD TML',
      'submissionTimeTitle': 'Submission time',
      'pleaseSelectRateTypePrompt': 'Please select the rate type',
      'carrierCompanyTitle': 'Carrier',
      'contractNoTitle': 'Contract No.',
      'loadingTitle': 'Loading',
      'emptyCacheMenu': 'Clear Cookie',
      'partialParsingSuccessPrompt': 'Partial parsing success',
      'uploadSuccessCanViewParsingResultUploadRecordPrompt': 'If the upload is successful, you can view the parsing result in the upload record',
      'nationalDockRuleTitle': 'National dock rule',
      'displayColumnButton': 'Display column',
      'pleaseEnterRouteCodePrompt': 'Please enter the service',
      'portMatchingSuccessRatePrompt': 'Port matching success rate',
      'InvalidParamsException': 'Parameter exceptions',
      'throughTitle': 'Through',
      'monthlyTitle': 'Monthly',
      'pleaseSelectCarrierPrompt': 'Please select a carrier',
      'feeDetailsTitle': 'Fee details',
      'notTitle': 'Not',
      'fullVolumeGoesOfflineMenu': 'Full volume goes offline',
      'rateLabel': 'Rate Label',
      'specialContainerTitle': 'Special container',
      'batchEditValidityPeriodButton': 'Edit all validity',
      'modesTransportTitle': 'Modes of transport',
      'greenTitle': 'Green',
      'purpleTitle': 'Purple',
      'viewDetailButton': 'Detail',
      'shippingScheduleEmptyTitle': 'TBN',
      'bulkPutOnButton': 'Batch put on',
      'youCanDownloadImportTemplateToImport': 'you can download the import template to import',
      'pleaseCheckFilterDataPerformOperationPrompt': 'Please check or filter the data to perform the operation',
      'clearTheLabel': 'Are you sure you want to clear the label?',
      'MessageNoticePushId_IsNotEmpty_Exception': 'Message notice push id cannot be empty',
      'Currency_IsNotEmpty_Exception': 'Currency cannot be empty',
      'saveSuccessfullyPleaseCheckMyQuotePrompt': 'Save successfully, please check in My Quote',
      'toImportPrompt': 'To import',
      'pleaseSelectPrompt': 'Please select ',
      'SuccessException': 'Success',
      'ProductId_IsNotEmpty_Exception': 'Product id cannot be empty',
      'containerVolumeTitle': 'Container volume',
      'pleaseSelectCommodityGroupPrompt': 'Please select a Commodity group',
      'downlinePersonTitle': 'Downline person',
      'GuideSalePrice_IsNotEmpty_Exception': 'Suggest selling cannot be empty',
      'historyVersionTitle': 'History Version',
      'publisherTitle': 'Publisher',
      'scheduleSourceTitle': 'Schedule source',
      'fridayTitle': 'Fri',
      'etdTitle': 'ETD',
      'makeSureSystemFieldPresentHeaderPrompt': 'and make sure the system field is present in the header,',
      'uploadedPersonTitle': 'Creater',
      'pleaseSelectRateStatusPrompt': 'Please select the rate status',
      'overwriteLegacyScenarioPrompt': 'Overwrite the legacy scenario',
      'isDisabledTitle': 'Is Disabled',
      'conditionComparatorIsEmptyPrompt': 'The condition comparator is empty',
      'surchargeDetailsMenu': 'Surcharge Detail',
      'pleaseEnterPlaceOfReceiptTitle': 'Origin',
      'quotationNumberTitle': 'Quotation Number',
      'cascadeAddressesTitle': 'Cascade addresses',
      'QuotationSurchargeInfo_IsNotEmpty': 'The cost details information of the quotation cannot be empty',
      'enoughTitle': 'Enough',
      'salesSideTitle': 'Sales',
      'freightPrepaidTotalTitle': 'Freight Prepaid Total',
      'includeOrNotTitle': 'Is include total price',
      'pleaseEnterContainerSizeTypePrompt': 'Please enter the container size type',
      'pleaseSelectARouteCodePrompt': 'Please select a service',
      'rateManagementMenu': 'Rate',
      'productManagementMenu': 'Product management',
      'expandTitle': 'Unfold',
      'priorityTitle': 'Priority',
      'advanceTitle': 'Advance',
      'closeBillDateTitle': 'Cut Off Date',
      'deleteCurrentMarkupRulePrompt': 'Deleting the current rule will automatically cancel the markup information of the relevant product, do you want to continue to delete?',
      'freetimeDayTitle': 'Freetime day',
      'lowerLimitWeightTitle': 'Lower limit weight',
      'MessageType_IsNotEmpty_Exception': 'Message type cannot be empty',
      'confirmWantShelvesProductPrompt': 'Are you sure you want to list?',
      'CarrierId_IsRequired_Exception': 'Carrier id is required',
      'exportAllDataButton': 'Export all data',
      'chargeTicketTitle': 'Fee(bill)',
      'rateDataHasChangedRateLockedNotTriggeredMatchRulePrompt': 'The rate data has changed, and the rate is locked, and the rule matching will not be triggered, do you continue?',
      'scheduleDataDuplicatedPleaseSelectAgainPrompt': 'Schedule data has been duplicated, please select again',
      'The_Amount_Of_Data_Is_Too_Large': 'The number of freight rates used to generate the quotation exceeds the maximum',
      'markupCoveragePrompt': 'Markup coverage',
      'ruleNameTitle': 'Rule name',
      'moderateButton': 'Moderate',
      'rolePermissionManagementMenu': 'Role authority management',
      'bargeTitle': 'Barge',
      'QuotationPricesRateDetail_IsNotEmpty_Exception': 'Quotation Prices detail cannot be empty',
      'listingFailedPrompt': 'Listing failed',
      'distributionStatusTitle': 'Distribution status',
      'voyageTitle': 'Voyage No',
      'addUnloadingPointButton': 'Add unloading point',
      'bulkQuotesTitle': 'Bulk quotes',
      'closePortDateTitle': 'CY Close Date',
      'TelTitle': 'Tel',
      'confirmWantDeleteSurchargePrompt': 'Are you sure you want to remove the surcharge?',
      'bulkEditValidityPeriodButton': 'Batch edit validity',
      'modifyButton': 'Edit',
      'PortCode_IsRequired_Exception': 'Port code is required',
      'dataSourceTitle': 'Data source',
      'QueryParams_IsNotEmpty_Exception': 'Query params cannot be empty',
      'bulkMakeQuotationsMenu': 'Batch Quote',
      'systemSettingMenu': 'Settings',
      'yesTitle': 'Yes',
      'listingProcessingPrompt': 'Listing processing',
      'disassociationButton': 'Disassociation',
      'closePortScheduleTitle': 'CY Close Voyage',
      'SelectedAll_IsNotEmpty_Exception': 'Whether all is selected cannot be empty',
      'keepTitle': 'Keep',
      'nationalTitle': 'National',
      'distributionRateMenu': 'Distribution Rate',
      'thisWillRemoveAllFilteredDataFromTheShelvesPleaseCheckAgainPrompt': 'This will remove all filtered data from the shelves, please check again',
      'feederChargesMenu': 'Feeder Charge',
      'shipOperatorTitle': 'Ship Owner',
      'ChargeUnit_IsRequired_Exception': 'Charge Unit is required',
      'endPointTitle': 'End point',
      'sortNoTitle': 'NO.',
      'TicketCost_IsNotEmpty_Exception': 'Ticket cost cannot be empty',
      'rateValidityPeriodTitle': 'Validity',
      'departurePortFeeTitle': 'Departure port Fee',
      'filterButton': 'Filter',
      'billingUnitTitle': 'Billing unit',
      'editPriceMarkupRuleTitle': 'Edit price markup rule',
      'flushButton': 'Flush',
      'importContractButton': 'Import',
      'validityPeriodStartDateTitle': 'EFFDATE',
      'personalSettingMenu': 'Setting',
      'downlineTitle': 'Downline',
      'fullDelistingButton': 'Not show all',
      'updateRateInfoPrompt': 'update rate info',
      'pleaseSelectPriceColorPrompt': 'Please select a price color',
      'IsAllInCalculate_IsNotEmpty_Exception': 'Whether or not to participate in the ALL IN calculation cannot be null',
      'myPrebookingMenu': 'Pre-booking',
      'firstVesselTitle': 'First vessel',
      'setTheListTitle': 'Set the list',
      'placeDepartureTitle': 'Place of departure',
      'pleaseSelectPaymentMethodPrompt': 'Please select a payment method',
      'pleaseSelectCarrierScheduleStatusPrompt': 'Please select the shipment schedule status',
      'distributionPriceTitle': 'Distribution price',
      'rateInquiryMenu': 'Price Inquiry',
      'QuotationPricesType_NotExist_Exception': 'Quotation prices type does not exist',
      'SelectedDataIsBeingModifiedOrIsNotEligibleForEditingPleaseTryAgainLater_Exception': 'The selected data is being modified or is not eligible for editing, please try again later',
      'ParseMode_IsRequired_Exception': 'Parse mode is required',
      'cabinProtectionInfoRepeatedPrompt': 'Cabin protection info Repeated',
      'addCarrierSurchargeTitle': 'Add carrier surcharge',
      'closeOtherButton': 'Close other',
      'parsingFailedPrompt': 'Parsing failed',
      'freeDetentionMenu': 'Dnd',
      'freeDetentionDetailMenu': 'Dnd Detail',
      'operationFailedPrompt': 'Operation failed',
      'InitializationRateVersionInfoFailed_Exception': 'Initialization rate version info failed',
      'tuesdayTitle': 'Tues',
      'confirmWantToDeletePrompt': 'Are you sure you want to delete?',
      'surchargeManagementMenu': 'Surcharge',
      'listedTitle': 'Listed',
      'confirmWantRefusePrompt': 'Are you sure you want to refuse?',
      'pleaseEnterMarkupAmountPrompt': 'Please enter the markup amount',
      'ProductInfo_Exception': 'Product info exception',
      'DataAlreadyExists_Exception': 'Data already exists',
      'expiredTitle': 'Expired',
      'duplicateDataLineNumberTitle': 'Duplicate data (line number)',
      'downlineTypeTitle': 'Downline type',
      'companyTitle': 'Company',
      'SubscriptionIdMissing_Exception': 'Subscription ID is missing',
      'confirmWantDisableProductPrompt': 'Are you sure you want to disable your product?',
      'dataDuplicationPrompt': 'Data duplication（line No.）',
      'pleaseSelectShippingMethodPrompt': 'Please select a shipping method',
      'associatedSurchargeDetailTitle': 'Associated surcharge details',
      'createProjectButton': 'Create project',
      'preBookingOrderApproveNoticePrompt': 'Pre-Booking order approve notice',
      'DataStatusOfTheSelectedDataIsNotEligibleForModificationPleaseTryAgainLater_Exception': 'The data status of the selected data is not eligible for modification, please try again later',
      'notStartedTitle': 'Not started',
      'freightPrepaidTitle': 'Freight prepaid',
      'moduleTitle': 'Module',
      'pleaseEnterContractNoPrompt': 'Please enter the contract no.',
      'putOnButton': 'Put On',
      'VersionNo_GenerateFailed_Exception': 'Version no generate failed',
      'pleaseEnterPortPrompt': 'Please enter a port',
      'guideSalePriceTitle': 'Suggest selling',
      'editButton': 'Edit',
      'polTitle': 'POL',
      'distributionMarkupTitle': 'Distribution markup',
      'employeeManagementMenu': 'Employee management',
      'confirmWantGoOfflinePrompt': 'Are you sure you want to go offline?',
      'dingTalkTitle': 'DingTalk',
      'weeklyTitle': 'Weekly',
      'editRateTitle': 'Edit Rate',
      'trailerTitle': 'Trailer',
      'systemContractNoTitle': 'Sys Contract No.',
      'goToPageButton': 'Go to page',
      'promptTitle': 'Prompt',
      'pleaseSelectRouteCategoryPrompt': 'Please select a route category',
      'SurchargeName_IsRepeated_Exception': 'Surcharge name cannot be repeated',
      'contractIdTitle': 'Contract ID',
      'ScheduleStatus_IsNotEmpty_Exception': 'Schedule id cannot be empty',
      'delayTitle': 'Delay',
      'onlyModifiedUnlistedFailedRateStatusPrompt': 'Only the tariff of the [Not listed/Failed to list/Expired] status can be modified',
      'pleaseSelectOwnerPrompt': 'Please select the owner',
      'freightCollectTitle': 'Freight collect',
      'transferTerminalTitle': 'Transit port',
      'pleaseEnterDestinationPortTerminalPrompt': 'Please enter the pod tml',
      'moreButton': 'More',
      'confirmWantEnableRulePrompt': 'Are you sure you want to enable tags?',
      'LanguagePackageId_IsNotEmpty_Exception': 'Language package id cannot be empty',
      'Surchargefullamountmodification': 'OnlyModifiedUnlistedFailedRateStatusPrompt [Enabled/Disabled/Not Started] is supported',
      'pleaseEnterEndPointPrompt': 'Please enter the end point',
      'setTheListDisplayFieldTitle': 'Set the list display field',
      'FileUrlNotFound_Exception': 'File URL not found',
      'editValidityPeriodButton': 'Edit validity',
      'LanguageResource_IsNotExist_Exception': 'Language resource does not exist',
      'RateValidityPeriod_IsRepeated_Exception': 'Rate validity cannot be repeated',
      'LanguageResourceKey_AlreadyExists_Exception': 'Language resource key already exists',
      'rateAnalysisCompletedPrompt': 'Rate analysis completed',
      'theActualPriceIsSubjectToTheShippingCompanyPrompt': 'The actual price is subject to the shipping company',
      'surchargeRulesMenu': 'Match Rule',
      'organizationMenu': 'Organization',
      'BatchModifyParams_IsNotEmpty_Exception': 'Batch modify params cannot be empty',
      'thisWillDeleteAllFilteredDataPleaseConfirmAgainPrompt': 'This will delete all filtered data, please confirm again',
      'onlyModifiedListedUnlistedInvalidatedFailedLaunchedRateStatusPrompt': 'Only the tariff in the status of [Not listed/Invalidated/Listed/Failed] is supported',
      'uploadSuccessParsingResultUploadRecordPrompt': 'If the upload is successful, you can view the parsing result in the upload record',
      'receiveTaskRateResolutionPrompt': 'Receive the task of rate resolution',
      'PleaseSelectDataInUse_Exception': 'Please select [In use] data',
      'FullListing_OperationFailed_Exception': 'Full listing operation failed',
      'messageRemindSettingMenu': 'Message Remind Setting',
      'distributionSuccessMenu': 'Distribution Success',
      'surchargeMenu': 'Surcharge',
      'costPriceUsdTitle': 'Net Cost(USD)',
      'QuotationContainerInfo_IsNotEmpty': 'The container type quantity of the quotation cannot be empty',
      'historyProjectedTitle': 'History projected',
      'ProductInfo_NotExist_Exception': 'Product info does not exist',
      'pleaseSelectDestinationTerminalDockPrompt': 'Please select the pod tml',
      'loadScheduleDataTitle': 'Load schedule data',
      'containerSizeTypeTitle': 'Container Size Type',
      'submitterTitle': 'Submitter',
      'exportButton': 'Export',
      'SurchargeCategory_IsNotEmpty_Exception': 'The surcharge category cannot be empty',
      'scheduleStatusTitle': 'Schedule Status',
      'ownerTitle': 'Owner',
      'ContainerCostUpdateInfo_IsNotEmpty_Exception': 'Container cost update info cannot be empty',
      'filterCriteriaTitle': 'Filter By',
      'downloadTitle': 'Download',
      'contractRateMenu': 'S/C Rate',
      'onlineImportTitle': 'Online import',
      'OnlineRateInquiryFailed_Exception': 'Online freight rate query failed',
      'nervousTitle': 'Nervous',
      'modificationTime': 'Modification time',
      'modifier': 'Modifier',
      'eventTypeTitle': 'Event Type',
      'boxGenus': 'COC/SOC',
      'batchCopy': 'Batch copy',
      'bulkCopyTips1': 'If you enter content in the following fields, update the copied data according to the entered content；',
      'bulkCopyTips2': 'If no content is entered in the following fields, keep the existing data of the freight rate for copying；',
      'checkThisTime': 'Check this time',
      'successfullyCopied': 'Successfully copied',
      'tradeTitle': 'Trade',
      'spotRateTitle': 'SpotRate',
      'seawinSystem': 'Seawin System',
      'seawinDistributionStatus': 'Seawin Distribution Status',
      'offlineNotSupported': 'Offline is not supported',
      'rateOverview': 'Rates Overview',
      'listedRatesClassifiedByRoute': 'Listed Rates Classified By Route',
      'realtimeData': 'Realtime',
      'rateInquiryQuotationRankingList': 'Inquiry/Quotation',
      'lastWeek': 'LastWeek',
      'inquiryWithResultOrNot': 'Inquiry With Result Or Not',
      'abnormalPrice': 'Abnormal Price',
      'abnormalMatchingOfVoyageSchedule': 'Abnormal Matching OF Voyage Schedule',
      'rateExpirationWarning': 'Rate Expiration Warning',
      'inquiryCounts': 'Inquiry Counts',
      'numberOfVoyageScheduleMatchingHits': 'Number of Voyage Schedule Matching Hits',
      'dashboard_filter_branchs': 'Subsidiary company',
      'numberOfVoyageScheduleMatchingFailed': 'Number of Voyage Schedule Matching Failed',
      'failureRate': 'Failure Rate',
      'expiredIn3Days': 'Expired In 3 Days',
      'expiredIn10Days': 'Expired In 10 Days',
      'expiredIn30Days': 'Expired In 30 Days',
      'homePageHI': 'HI',
      'thisIsYourNO': 'THIS IS YOUR NO.',
      'login': 'LOGIN',
      'cabinCapacity': 'Cabin capacity',
      'numberOfCabins': 'Number of cabins',
      'bookingQuantity': 'Booking quantity',
      'subjectToConfirmationWithTheRoute': 'Subject to confirmation with the route',
      'expireds': 'Expired',
      'totalRate': 'Total rate',
      'commonFunctions': 'Common functions',
      'costGuidedsellingPrice': 'Cost price/guided selling price',
      'inquiryHome': 'Inquiry',
      'quotationHome': 'Quotation',
      'noRate': 'No rate',
      'rateAvailable': 'Rate available',
      'dataBI': 'BI',
      'noDistribution': 'No Distribution',
      'distributionFailure': 'Distribution Failure',
      'inDistribution': 'In Distribution',
      'addDnd': 'Add Dnd',
      'editDnd': 'Edit Dnd',
      'exemptionPeriodInformation': 'Exemption period information',
      'enterTheNumberOfFreeDays': 'Please enter the number of free days',
      'selectDndType': 'Please select the type',
      'freeTime': 'Free Time',
      'demurrageDay': 'Free Detention',
      'detentionDay': 'Free Demurrage',
      'dayType': 'Day Type',
      'dndType': 'Dnd type',
      'originalid': 'Original ID',
      'rateSource': 'Rate Source',
      'offlineSelectedRate': 'Offline Selected Rate',
      'NoNeedToSelectAllRatesWillBeOffline': 'No need to select, all rates will be taken offline. Please be cautious and only support GeekYum Best.',
      'NoNeedToSelectAllRatesWillBDistributed': 'No need to select, all rate will be fully distributed.',
      'distributAll': 'All Distribut',
      'areYouSureFullDistribution': 'Are you sure you want full distribution?',
      'areYouSureYouWantOfflineAllRate': 'Are you sure you want to go offline all rate?',
      'automaticDistributionRateMenu': 'Automatic Distribution',
      'addDistributionRule': 'Add Distribution Rule',
      'editDistributionRule': 'Edit Distribution Rule',
      'pleaseSelectAtLeasOne': 'Please select at least one of the following filters',
      'podNationalTitle': 'POD National',
      'ifETD': 'ETD',
      'isOMSBinding': 'OMS Binding',
      'lastModify': 'Last Modify',
      'lastModifyTime': 'Last Modify Time',
      'Exporting': 'Exporting',
      'dataNotBoundOMS': 'Data Not Bound To OMS',
      'modificationOfMarkupRules': 'After modifying the markup rules, in order to ensure the accuracy of price calculation, please wait for 30 minutes before proceeding with the existing freight rates in the system;',
      'announcementSet': 'System Announcement Settings',
      'newAnnouncement': 'New Announcement',
      'editAnnouncement': 'Edit Announcement',
      'announcementContent': 'Announcement',
      'announcementValidityPeriod': 'Period Of Validity',
      'updatedByDepartment': 'Department',
      'realTimePopupDisplay': 'Real time pop-up display',
      'realTimeScrollingDisplay': 'Real time scrolling display',
      'enablePopup': 'Enable Popup',
      'cancelPopup': 'Cancel Popup',
      'enableScrolling': 'Enable scrolling',
      'cancelScrolling': 'Cancel Scrolling',
      'systemAnnouncement': 'System Announcement',
      'publisher': 'Publisher',
      'todayAc': 'Today',
      'yesterdayAc': 'Yesterday',
      'allAc': 'ALL',
      'announcementSwitch': 'Announcement switch',
      'wccPlatform': 'WCC Platform',
      'wccDistributionStatus': 'WCC Distribution Status',
      'freightCode': 'Freight code',
      'distributionCode': 'Distribution Code',
      'queryTime': 'Query time',
      'freightStatusChangeTitle': 'Freight status change',
      'priceMarkup1': 'After submitting the fare increase rule, the system needs some time to process it. Please wait for 30 minutes before taking any other actions on the existing fare in the system',
      'priceMarkup2': 'After submission, only the rates that have not been listed or have failed to be listed will be automatically increased. If you need to modify the rates that have been listed, you can remove them first and then modify the increase rules',
      'changeRecord2': 'The rate change record only records the offline rate table, which is updated every 3 minutes',
      'changeRecord1': 'and the changes have been marked in red',
      'viewPriceMarkupRuleTitle': 'View price markup rule',
      'enterAisc': 'Enter AISC',
      'yaDongChannelStatus': 'YaDong Channel Status',
      'anHaiChannelStatus': 'AnHai Channel Status',
      'anHaiChannelYaDong': 'AnHai Channel YaDong',
      'loxsonYaDong': 'LOXSON YaDong',
      'quanQiuChannelJinCheng': 'QuanQiu Channel JinCheng',
      'jinChengChannelStatus': 'QuanQiu Channel Status',
      'contractOrBatch': 'Contract No. / Batch No.',
      'underModification': 'Under Modification',
      'batchNoTitle': 'Batch No.',
      'rateSubscribed': 'Subscribe',
      'rateSubscribed1': 'Rate subscribed',
      'subscription': 'Subscribe',
      'unSubscribe': 'Unsubscribe',
      'subscribedService': 'Subscribed service',
      'subscribedCarrier': 'Subscribed carrier',
      'numberRates': 'Subscribable number of freight rates',
      'subOption': 'Sub Option',
      'PleaseSelectItem': 'Please select at least one item',
      'salesCompanyDisplay': 'Sales end company display',
      'displaySalesContactPerson': 'Display of sales contact person',
      'subscriptionSuccessful': 'Subscription successful',
      'selected': 'Selected',
      'successfullySubscribedSalesEnd': 'The freight has been successfully subscribed, please go to [offline freight] to manage and operate the listing',
      'automaticallyNeeded': 'Automatically update subscribed routes and carrier rates daily. If not needed',
      'subscribedList': 'Subscribed list',
      'afterCancel': 'After canceling the subscription, you will no longer receive fares from this supplier. Are you sure to cancel?',
      'deselectAll': 'Deselect All',
      'subscribableService': 'Subscribable service',
      'subscribableCarrier': 'Subscribable carrier',
      'settingShippingSchedule': 'Setting of shipping schedule',
      'salesEntrance': 'Sales entrance',
      'polCode': 'POL Code',
      'podCode': 'POD Code',
      'contractType': 'Contract type',
      'carriageClause': 'Carriage clause',
      'append': 'Append',
      'defaultSupplier': 'Default Supplier',
      'guidingSellingPrice': 'Is it the Guiding Selling Price',
      'automaticallyMarkup': 'The freight rate is imported into the system to automatically match the markup rules and synchronously generate the guiding selling price.',
      'automaticallyNoMarkup': 'The freight rate import system is no longer in accordance with the markup rules. The obtained value is directly taken as the guiding selling price.',
      'isItPlacedOnTop': 'Is it placed on top',
      'top': 'Top',
      'cancelTop': 'Cancel Top',
      'areYouSureYouWanOnTop': 'Are you sure you want to put it on top?',
      'areYouSureYouWantCancelTopPlacement': 'Are you sure you want to cancel the top placement?',
      'import': 'Import',
      'departureSectionCost': 'Departure section cost',
      'destinationSectionCost': 'Destination section cost',
      'inlandFreightDetails': 'Inland Freight Details',
      'copyInlandFreights': 'Copy inland freights',
      'porDockTitle': 'POR TML',
      'pleaseEnterTheFeeDetails': 'Please enter the fee details',
      'inEffect': 'In effect',
      'theInlandFreight': 'The inland freight rate will not be effective until it is updated and re-listed',
      'associateOrigin': 'Associate origin - leg freight',
      'associateDestination': 'Associate destination - leg freight',
      'generalCargoSchedule': 'Bulk Solution',
      'searchRecs': 'Search Recs',
      'destinationPortLineTitle': 'Destination Port line',
      'searchType': 'Search type',
      'userSource': 'User source',
      'username': 'User name',
      'mailbox': 'Mailbox',
      'searchResult': 'Search result',
      'shippingSpaceRemind': 'Shipping Space Remind',
      'addShippingSpaceRemind': 'Add Shipping Space Remind',
      'editShippingSpaceRemind': 'Edit Shipping Space Remind',
      'copyShippingSpaceRemind': 'Copy Shipping Space Remind',
      'exportTime': 'Export time',
      'inlandFreightRateImportButton': 'Inland freight import',
      'contractSetting': 'Contract Setting',
      'automaticOverlappingCorrection': 'Automatic Overlapping Correction',
      'overlapAndConnection': 'Overlap And Connection',
      'disableDuringOverlap': 'Disable During Overlap',
      'noNotEnableCorrection': 'No Not Enable Correction',
      'whenTheSystemDetectsOverlappingContractDates:': 'When The System Detects Overlapping ContractDates',
      'contractStartTimeDay': 'If the validity period of the freight rate is an intersection relationship, the end time of the old contract should be changed to the day before the start of the new contract to ensure a seamless transition.',
      'willImmediatelyContract': 'If the validity period of the freight rate is a cumulative relationship, the end time of the old contract should be advanced to before the start of the new contract, and the new contract shall take effect first.',
      'willDisableContracts': 'When the system detects overlapping contract dates, it will disable the old contracts.',
      'disableAutomaticCorrectionContracts': 'Disable automatic correction and manually modify overlapping contracts',
      'routeScheduleSettings': 'Schedule settings',
      'newRouteCodeScheduleRules': 'New route code schedule rules',
      'editRouteCodeScheduleRules': 'Edit route code schedule rules',
      'copyRouteCodeScheduleRules': 'Copy route code schedule rules',
      'uniqueId': 'Unique ID',
      'routeCodeConditions': 'Route code conditions',
      'shippingScheduleReturnRulesPleaseSelectAnyOneRule': 'Shipping schedule return rules (please select any one rule)',
      'exclude': 'Exclude',
      'include': 'Include',
      'pleaseSelectThePortDeparture': 'Please select the port of departure',
      'pleaseSelectLeastOneShippingScheduleReturnOption': 'Please select at least one shipping schedule return option',
      'customTemplateImport': 'Custom template import',
      'afterImportingUploadList': 'After importing, please check the import results in the [Upload List] section',
      'fareVersion': 'Fare Version'
    }
  }
}
const localStorageHelp = {
  get: (key) => {
    let result = window.localStorage.getItem(key)
    result = result ? (typeof result === 'string' ? JSON.parse(result) : result) : null
    if (!result) return null

    const { value, expireTime } = result
    if (expireTime > new Date().getTime()) {
      return value
    }
    return null
  },
  /**
   *
   * @param key
   * @param value
   * @param expire 单位：秒
   */
  set: (key, value, expire = 1) => {
    const obj = {
      value,
      expireTime: new Date().getTime() + 1000 * expire
    }
    window.localStorage.setItem(key, JSON.stringify(obj))
  }
}

/**
 * cookie 存储的key
 * @type {string}
 */
export const getLangKey = (extra = '') => extra ? `${config.baseLangKey}_${extra}` : config.baseLangKey

export const toggleLanguage = async(languageCode, ctx, callback) => {
  if (!languageCode) {
    languageCode = Cookie.getCookie(getLangKey(), null, false) || 'zh_CN'
  }

  // storage
  const storageKey = getLangKey(languageCode)
  let msgLang = localStorageHelp.get(storageKey)
  msgLang = msgLang ? (typeof msgLang === 'string' ? JSON.parse(msgLang) : msgLang) : null
  if (!msgLang) {
    // const data = await ctx.$store.dispatch('language/getLanguage', {packageName: 'giga', languageCode: languageCode} )
    const data = localLangMap[languageCode]
    if (!data || !data.filedMap) return
    msgLang = data.filedMap
    localStorageHelp.set(storageKey, msgLang, config.expireTime)
  }
  // 设置 i18n
  const lang = ctx.$i18n.getLocaleMessage(languageCode)
  ctx.$i18n.setLocaleMessage(languageCode, { ...lang, msg: msgLang })
  ctx.$i18n.locale = languageCode
  // 采用cookie记录langKey，前后端通用
  Cookie.setCookie(getLangKey(), { value: languageCode, domain: BASE_URL.DOMAIN_URL }, false)
  // 设置storage记录langKey，组件里面使用
  const projectLangKey = getLangKey(config.projectLanguageKey)
  localStorageHelp.set(projectLangKey, languageCode, 3600 * 24 * 3650)

  // 这里做一些业务上相关的、不一定通用的事情
  if (callback && typeof callback === 'function') {
    callback({ langKey: getLangKey() })
  }
}

export const getLabelByCode = (code = Cookie.getCookie(getLangKey(), null, false) || 'zh_CN') => (config.langList)[code]
